export const country_code = [
    {
        "country": {
            "code": "AD",
            "code3": "AND",
            "phoneCode": "376",
            "nameEn": "Andorra",
            "nameLocal": "Andorra",
            "isoNumeric": 20
        },
        "currency": {
            "code": "EUR",
            "nameEn": "Euro",
            "symbol": "€",
            "paypal": "1",
            "stripe": "1"
        },
        "official": {
            "code": "ca",
            "nameEn": "Catalan, Valencian",
            "nameLocal": "Català, Valencià"
        },
        "tin": {
            "name": "",
            "type": ""
        },
        "flag": "🇦🇩",
        "region": "Europe"
    },
    {
        "country": {
            "code": "AF",
            "code3": "AFG",
            "phoneCode": "93",
            "nameEn": "Afghanistan",
            "nameLocal": "د افغانستان اسلامي دولتدولت اسلامی افغانستان, جمهوری اسلامی افغانستان",
            "isoNumeric": 4
        },
        "currency": {
            "code": "AFN",
            "nameEn": "Afghan afghani",
            "symbol": "؋",
            "paypal": "0",
            "stripe": "1"
        },
        "official": {
            "code": "fa",
            "nameEn": "Persian",
            "nameLocal": "فارسی"
        },
        "tin": {
            "name": "",
            "type": ""
        },
        "flag": "🇦🇫",
        "region": "Asia & Pacific"
    },
    {
        "country": {
            "code": "AG",
            "code3": "ATG",
            "phoneCode": "1268",
            "nameEn": "Antigua and Barbuda",
            "nameLocal": "Antigua and Barbuda",
            "isoNumeric": 28
        },
        "currency": {
            "code": "XCD",
            "nameEn": "East Caribbean dollar",
            "symbol": "$",
            "paypal": "0",
            "stripe": "1"
        },
        "official": {
            "code": "en",
            "nameEn": "English",
            "nameLocal": "English"
        },
        "tin": {
            "name": "",
            "type": ""
        },
        "flag": "🇦🇬",
        "region": "South/Latin America"
    },
    {
        "country": {
            "code": "AI",
            "code3": "AIA",
            "phoneCode": "1264",
            "nameEn": "Anguilla",
            "nameLocal": "Anguilla",
            "isoNumeric": 660
        },
        "currency": {
            "code": "XCD",
            "nameEn": "East Caribbean dollar",
            "symbol": "$",
            "paypal": "0",
            "stripe": "1"
        },
        "official": {
            "code": "en",
            "nameEn": "English",
            "nameLocal": "English"
        },
        "tin": {
            "name": "",
            "type": ""
        },
        "flag": "🇦🇮",
        "region": "South/Latin America"
    },
    {
        "country": {
            "code": "AL",
            "code3": "ALB",
            "phoneCode": "355",
            "nameEn": "Albania",
            "nameLocal": "Shqipëria",
            "isoNumeric": 8
        },
        "currency": {
            "code": "ALL",
            "nameEn": "Albanian lek",
            "symbol": "Lek",
            "paypal": "0",
            "stripe": "1"
        },
        "official": {
            "code": "sq",
            "nameEn": "Albanian",
            "nameLocal": "Shqip"
        },
        "tin": {
            "name": "Numri i Identifikimit për Personin e Tatueshëm",
            "type": "NIPT"
        },
        "flag": "🇦🇱",
        "region": "Europe"
    },
    {
        "country": {
            "code": "AO",
            "code3": "AGO",
            "phoneCode": "244",
            "nameEn": "Angola",
            "nameLocal": "Angola",
            "isoNumeric": 24
        },
        "currency": {
            "code": "AOA",
            "nameEn": "Angolan kwanza",
            "symbol": "Kz",
            "paypal": "",
            "stripe": ""
        },
        "official": {
            "code": "pt",
            "nameEn": "Portuguese",
            "nameLocal": "Português"
        },
        "tin": {
            "name": "",
            "type": ""
        },
        "flag": "🇦🇴",
        "region": "Africa"
    },
    {
        "country": {
            "code": "AQ",
            "code3": "ATA",
            "phoneCode": "672",
            "nameEn": "Antarctica",
            "nameLocal": "Antarctica, Antártico, Antarctique, Антарктике",
            "isoNumeric": 10
        },
        "currency": {
            "code": "",
            "nameEn": "",
            "symbol": "",
            "paypal": "",
            "stripe": ""
        },
        "official": {
            "code": "en",
            "nameEn": "English",
            "nameLocal": "English"
        },
        "tin": {
            "name": "",
            "type": ""
        },
        "flag": "🇦🇶",
        "region": "Asia & Pacific"
    },
    {
        "country": {
            "code": "AR",
            "code3": "ARG",
            "phoneCode": "54",
            "nameEn": "Argentina",
            "nameLocal": "Argentina",
            "isoNumeric": 32
        },
        "currency": {
            "code": "ARS",
            "nameEn": "Argentine peso",
            "symbol": "$",
            "paypal": "0",
            "stripe": "1"
        },
        "official": {
            "code": "es",
            "nameEn": "Spanish, Castilian",
            "nameLocal": "Español"
        },
        "tin": {
            "name": "Código Único de Identificación Tributaria",
            "type": "CUIT"
        },
        "flag": "🇦🇷",
        "region": "South/Latin America"
    },
    {
        "country": {
            "code": "AS",
            "code3": "ASM",
            "phoneCode": "1684",
            "nameEn": "American Samoa",
            "nameLocal": "American Samoa",
            "isoNumeric": 16
        },
        "currency": {
            "code": "USD",
            "nameEn": "United States dollar",
            "symbol": "$",
            "paypal": "1",
            "stripe": "1"
        },
        "official": {
            "code": "en",
            "nameEn": "English",
            "nameLocal": "English"
        },
        "tin": {
            "name": "",
            "type": ""
        },
        "flag": "🇦🇸",
        "region": "Asia & Pacific"
    },
    {
        "country": {
            "code": "AT",
            "code3": "AUT",
            "phoneCode": "43",
            "nameEn": "Austria",
            "nameLocal": "Österreich",
            "isoNumeric": 40
        },
        "currency": {
            "code": "EUR",
            "nameEn": "Euro",
            "symbol": "€",
            "paypal": "1",
            "stripe": "1"
        },
        "official": {
            "code": "de",
            "nameEn": "German",
            "nameLocal": "Deutsch"
        },
        "tin": {
            "name": "Umsatzsteuer-Identifikationsnummer",
            "type": "UID"
        },
        "flag": "🇦🇹",
        "region": "Europe"
    },
    {
        "country": {
            "code": "AU",
            "code3": "AUS",
            "phoneCode": "61",
            "nameEn": "Australia",
            "nameLocal": "Australia",
            "isoNumeric": 36
        },
        "currency": {
            "code": "AUD",
            "nameEn": "Australian dollar",
            "symbol": "$",
            "paypal": "1",
            "stripe": "1"
        },
        "official": {
            "code": "en",
            "nameEn": "English",
            "nameLocal": "English"
        },
        "tin": {
            "name": "Australian Business Number",
            "type": "ABN"
        },
        "flag": "🇦🇺",
        "region": "Asia & Pacific"
    },
    {
        "country": {
            "code": "AW",
            "code3": "ABW",
            "phoneCode": "297",
            "nameEn": "Aruba",
            "nameLocal": "Aruba",
            "isoNumeric": 533
        },
        "currency": {
            "code": "AWG",
            "nameEn": "Aruban florin",
            "symbol": "ƒ",
            "paypal": "0",
            "stripe": "1"
        },
        "official": {
            "code": "nl",
            "nameEn": "Dutch, Flemish",
            "nameLocal": "Nederlands, Vlaams"
        },
        "tin": {
            "name": "",
            "type": ""
        },
        "flag": "🇦🇼",
        "region": "South/Latin America"
    },
    {
        "country": {
            "code": "AX",
            "code3": "",
            "phoneCode": "358",
            "nameEn": "Åland Islands",
            "nameLocal": "Åland",
            "isoNumeric": ""
        },
        "currency": {
            "code": "EUR",
            "nameEn": "Euro",
            "symbol": "€",
            "paypal": "1",
            "stripe": "1"
        },
        "official": {
            "code": "sv",
            "nameEn": "Swedish",
            "nameLocal": "Svenska"
        },
        "tin": {
            "name": "",
            "type": ""
        },
        "flag": "🇦🇽",
        "region": "Europe"
    },
    {
        "country": {
            "code": "AZ",
            "code3": "AZE",
            "phoneCode": "994",
            "nameEn": "Azerbaijan",
            "nameLocal": "Azərbaycan",
            "isoNumeric": 31
        },
        "currency": {
            "code": "AZN",
            "nameEn": "Azerbaijani manat",
            "symbol": "₼",
            "paypal": "0",
            "stripe": "1"
        },
        "official": {
            "code": "az",
            "nameEn": "Azerbaijani",
            "nameLocal": "azərbaycan dili"
        },
        "tin": {
            "name": "",
            "type": ""
        },
        "flag": "🇦🇿",
        "region": "Asia & Pacific"
    },
    {
        "country": {
            "code": "BA",
            "code3": "BIH",
            "phoneCode": "387",
            "nameEn": "Bosnia and Herzegovina",
            "nameLocal": "Bosna i Hercegovina",
            "isoNumeric": 70
        },
        "currency": {
            "code": "BAM",
            "nameEn": "Bosnia and Herzegovina convertible mark",
            "symbol": "KM",
            "paypal": "0",
            "stripe": "1"
        },
        "official": {
            "code": "bs",
            "nameEn": "Bosnian",
            "nameLocal": "bosanski jezik"
        },
        "tin": {
            "name": "",
            "type": ""
        },
        "flag": "🇧🇦",
        "region": "Europe"
    },
    {
        "country": {
            "code": "BB",
            "code3": "BRB",
            "phoneCode": "1246",
            "nameEn": "Barbados",
            "nameLocal": "Barbados",
            "isoNumeric": 52
        },
        "currency": {
            "code": "BBD",
            "nameEn": "Barbados dollar",
            "symbol": "$",
            "paypal": "0",
            "stripe": "1"
        },
        "official": {
            "code": "en",
            "nameEn": "English",
            "nameLocal": "English"
        },
        "tin": {
            "name": "",
            "type": ""
        },
        "flag": "🇧🇧",
        "region": "South/Latin America"
    },
    {
        "country": {
            "code": "BD",
            "code3": "BGD",
            "phoneCode": "880",
            "nameEn": "Bangladesh",
            "nameLocal": "গণপ্রজাতন্ত্রী বাংলাদেশ",
            "isoNumeric": 50
        },
        "currency": {
            "code": "BDT",
            "nameEn": "Bangladeshi taka",
            "symbol": "",
            "paypal": "",
            "stripe": ""
        },
        "official": {
            "code": "bn",
            "nameEn": "Bengali",
            "nameLocal": "বাংলা"
        },
        "tin": {
            "name": "",
            "type": ""
        },
        "flag": "🇧🇩",
        "region": "Asia & Pacific"
    },
    {
        "country": {
            "code": "BE",
            "code3": "BEL",
            "phoneCode": "32",
            "nameEn": "Belgium",
            "nameLocal": "België, Belgique, Belgien",
            "isoNumeric": 56
        },
        "currency": {
            "code": "EUR",
            "nameEn": "Euro",
            "symbol": "€",
            "paypal": "1",
            "stripe": "1"
        },
        "official": {
            "code": "nl",
            "nameEn": "Dutch, Flemish",
            "nameLocal": "Nederlands, Vlaams"
        },
        "tin": {
            "name": "BTW identificatienummer / Numéro de TVA",
            "type": "n° TVABTW-nr Mwst-nr"
        },
        "flag": "🇧🇪",
        "region": "Europe"
    },
    {
        "country": {
            "code": "BF",
            "code3": "BFA",
            "phoneCode": "226",
            "nameEn": "Burkina Faso",
            "nameLocal": "Burkina Faso",
            "isoNumeric": 854
        },
        "currency": {
            "code": "XOF",
            "nameEn": "CFA franc BCEAO",
            "symbol": "",
            "paypal": "",
            "stripe": ""
        },
        "official": {
            "code": "fr",
            "nameEn": "French",
            "nameLocal": "Français"
        },
        "tin": {
            "name": "",
            "type": ""
        },
        "flag": "🇧🇫",
        "region": "Africa"
    },
    {
        "country": {
            "code": "BG",
            "code3": "BGR",
            "phoneCode": "359",
            "nameEn": "Bulgaria",
            "nameLocal": "България",
            "isoNumeric": 100
        },
        "currency": {
            "code": "BGN",
            "nameEn": "Bulgarian lev",
            "symbol": "лв",
            "paypal": "0",
            "stripe": "1"
        },
        "official": {
            "code": "bg",
            "nameEn": "Bulgarian",
            "nameLocal": "български език"
        },
        "tin": {
            "name": "Идентификационен номер по ДДС",
            "type": "ДДС номер"
        },
        "flag": "🇧🇬",
        "region": "Europe"
    },
    {
        "country": {
            "code": "BH",
            "code3": "BHR",
            "phoneCode": "973",
            "nameEn": "Bahrain",
            "nameLocal": "البحرين",
            "isoNumeric": 48
        },
        "currency": {
            "code": "BHD",
            "nameEn": "Bahraini dinar",
            "symbol": "",
            "paypal": "",
            "stripe": ""
        },
        "official": {
            "code": "ar",
            "nameEn": "Arabic",
            "nameLocal": "العربية"
        },
        "tin": {
            "name": "",
            "type": ""
        },
        "flag": "🇧🇭",
        "region": "Arab States"
    },
    {
        "country": {
            "code": "BI",
            "code3": "BDI",
            "phoneCode": "257",
            "nameEn": "Burundi",
            "nameLocal": "Burundi",
            "isoNumeric": 108
        },
        "currency": {
            "code": "BIF",
            "nameEn": "Burundian franc",
            "symbol": "",
            "paypal": "",
            "stripe": ""
        },
        "official": {
            "code": "fr",
            "nameEn": "French",
            "nameLocal": "Français"
        },
        "tin": {
            "name": "",
            "type": ""
        },
        "flag": "🇧🇮",
        "region": "Africa"
    },
    {
        "country": {
            "code": "BJ",
            "code3": "BEN",
            "phoneCode": "229",
            "nameEn": "Benin",
            "nameLocal": "Bénin",
            "isoNumeric": 204
        },
        "currency": {
            "code": "XOF",
            "nameEn": "CFA franc BCEAO",
            "symbol": "",
            "paypal": "",
            "stripe": ""
        },
        "official": {
            "code": "fr",
            "nameEn": "French",
            "nameLocal": "Français"
        },
        "tin": {
            "name": "",
            "type": ""
        },
        "flag": "🇧🇯",
        "region": "Africa"
    },
    {
        "country": {
            "code": "BL",
            "code3": "",
            "phoneCode": "590",
            "nameEn": "Saint Barthélemy",
            "nameLocal": "Saint-Barthélemy",
            "isoNumeric": ""
        },
        "currency": {
            "code": "EUR",
            "nameEn": "Euro",
            "symbol": "€",
            "paypal": "1",
            "stripe": "1"
        },
        "official": {
            "code": "fr",
            "nameEn": "French",
            "nameLocal": "Français"
        },
        "tin": {
            "name": "",
            "type": ""
        },
        "flag": "🇧🇱",
        "region": "South/Latin America"
    },
    {
        "country": {
            "code": "BM",
            "code3": "BMU",
            "phoneCode": "1441",
            "nameEn": "Bermuda",
            "nameLocal": "Bermuda",
            "isoNumeric": 60
        },
        "currency": {
            "code": "BMD",
            "nameEn": "Bermudian dollar",
            "symbol": "$",
            "paypal": "0",
            "stripe": "1"
        },
        "official": {
            "code": "en",
            "nameEn": "English",
            "nameLocal": "English"
        },
        "tin": {
            "name": "",
            "type": ""
        },
        "flag": "🇧🇲",
        "region": "North America"
    },
    {
        "country": {
            "code": "BN",
            "code3": "BRN",
            "phoneCode": "673",
            "nameEn": "Brunei Darussalam",
            "nameLocal": "Brunei Darussalam",
            "isoNumeric": 96
        },
        "currency": {
            "code": "BND",
            "nameEn": "Brunei dollar",
            "symbol": "$",
            "paypal": "0",
            "stripe": "1"
        },
        "official": {
            "code": "ms",
            "nameEn": "Malay",
            "nameLocal": "Bahasa Melayu, بهاس ملايو‎"
        },
        "tin": {
            "name": "",
            "type": ""
        },
        "flag": "🇧🇳",
        "region": "Asia & Pacific"
    },
    {
        "country": {
            "code": "BO",
            "code3": "BOL",
            "phoneCode": "591",
            "nameEn": "Bolivia (Plurinational State of)",
            "nameLocal": "Bolivia, Bulibiya, Volívia, Wuliwya",
            "isoNumeric": 68
        },
        "currency": {
            "code": "BOP",
            "nameEn": "",
            "symbol": "$b",
            "paypal": "",
            "stripe": ""
        },
        "official": {
            "code": "es",
            "nameEn": "Spanish, Castilian",
            "nameLocal": "Español"
        },
        "tin": {
            "name": "Número de Identificación Tributaria",
            "type": "NIT"
        },
        "flag": "🇧🇴",
        "region": "South/Latin America"
    },
    {
        "country": {
            "code": "BQ",
            "code3": "",
            "phoneCode": "5997",
            "nameEn": "Bonaire, Sint Eustatius and Saba",
            "nameLocal": "Caribisch Nederland",
            "isoNumeric": ""
        },
        "currency": {
            "code": "USD",
            "nameEn": "United States dollar",
            "symbol": "",
            "paypal": "1",
            "stripe": "1"
        },
        "official": {
            "code": "nl",
            "nameEn": "Dutch, Flemish",
            "nameLocal": "Nederlands, Vlaams"
        },
        "tin": {
            "name": "",
            "type": ""
        },
        "flag": "🇧🇶",
        "region": "Unknown"
    },
    {
        "country": {
            "code": "BR",
            "code3": "BRA",
            "phoneCode": "55",
            "nameEn": "Brazil",
            "nameLocal": "Brasil",
            "isoNumeric": 76
        },
        "currency": {
            "code": "BRL",
            "nameEn": "Brazilian real",
            "symbol": "R$",
            "paypal": "1",
            "stripe": "1"
        },
        "official": {
            "code": "pt",
            "nameEn": "Portuguese",
            "nameLocal": "Português"
        },
        "tin": {
            "name": "Cadastro Nacional de Pessoa Jurídica",
            "type": "CNPJ"
        },
        "flag": "🇧🇷",
        "region": "South/Latin America"
    },
    {
        "country": {
            "code": "BT",
            "code3": "BTN",
            "phoneCode": "975",
            "nameEn": "Bhutan",
            "nameLocal": "འབྲུག་ཡུལ",
            "isoNumeric": 64
        },
        "currency": {
            "code": "BTN",
            "nameEn": "Bhutanese ngultrum",
            "symbol": "",
            "paypal": "",
            "stripe": ""
        },
        "official": {
            "code": "dz",
            "nameEn": "Dzongkha",
            "nameLocal": "རྫོང་ཁ"
        },
        "tin": {
            "name": "",
            "type": ""
        },
        "flag": "🇧🇹",
        "region": "Asia & Pacific"
    },
    {
        "country": {
            "code": "BV",
            "code3": "BVT",
            "phoneCode": "47",
            "nameEn": "Bouvet Island",
            "nameLocal": "Bouvetøya",
            "isoNumeric": 74
        },
        "currency": {
            "code": "NOK",
            "nameEn": "Norwegian krone",
            "symbol": "kr",
            "paypal": "1",
            "stripe": "1"
        },
        "official": {
            "code": "no",
            "nameEn": "Norwegian",
            "nameLocal": "Norsk"
        },
        "tin": {
            "name": "",
            "type": ""
        },
        "flag": "🇧🇻",
        "region": "South/Latin America"
    },
    {
        "country": {
            "code": "BW",
            "code3": "BWA",
            "phoneCode": "267",
            "nameEn": "Botswana",
            "nameLocal": "Botswana",
            "isoNumeric": 72
        },
        "currency": {
            "code": "BWP",
            "nameEn": "Botswana pula",
            "symbol": "P",
            "paypal": "0",
            "stripe": "1"
        },
        "official": {
            "code": "en",
            "nameEn": "English",
            "nameLocal": "English"
        },
        "tin": {
            "name": "",
            "type": ""
        },
        "flag": "🇧🇼",
        "region": "Africa"
    },
    {
        "country": {
            "code": "BY",
            "code3": "BLR",
            "phoneCode": "375",
            "nameEn": "Belarus",
            "nameLocal": "Беларусь",
            "isoNumeric": 112
        },
        "currency": {
            "code": "BYR",
            "nameEn": "",
            "symbol": "p.",
            "paypal": "0",
            "stripe": "0"
        },
        "official": {
            "code": "be",
            "nameEn": "Belarusian",
            "nameLocal": "беларуская мова"
        },
        "tin": {
            "name": "Учетный номер плательщика",
            "type": "УНП (UNP)"
        },
        "flag": "🇧🇾",
        "region": "Europe"
    },
    {
        "country": {
            "code": "BZ",
            "code3": "BLZ",
            "phoneCode": "501",
            "nameEn": "Belize",
            "nameLocal": "Belize",
            "isoNumeric": 84
        },
        "currency": {
            "code": "BZD",
            "nameEn": "Belize dollar",
            "symbol": "BZ$",
            "paypal": "0",
            "stripe": "1"
        },
        "official": {
            "code": "en",
            "nameEn": "English",
            "nameLocal": "English"
        },
        "tin": {
            "name": "",
            "type": ""
        },
        "flag": "🇧🇿",
        "region": "South/Latin America"
    },
    {
        "country": {
            "code": "CA",
            "code3": "CAN",
            "phoneCode": "1",
            "nameEn": "Canada",
            "nameLocal": "Canada",
            "isoNumeric": 124
        },
        "currency": {
            "code": "CAD",
            "nameEn": "Canadian dollar",
            "symbol": "$",
            "paypal": "1",
            "stripe": "1"
        },
        "official": {
            "code": "en",
            "nameEn": "English",
            "nameLocal": "English"
        },
        "tin": {
            "name": "Business Number",
            "type": "BN / NE"
        },
        "flag": "🇨🇦",
        "region": "North America"
    },
    {
        "country": {
            "code": "CH",
            "code3": "CHE",
            "phoneCode": "41",
            "nameEn": "Switzerland",
            "nameLocal": "Schweiz, Suisse, Svizzera, Svizra",
            "isoNumeric": 756
        },
        "currency": {
            "code": "CHE",
            "nameEn": "WIR Euro (complementary currency)",
            "symbol": "CHF",
            "paypal": "",
            "stripe": ""
        },
        "official": {
            "code": "de",
            "nameEn": "German",
            "nameLocal": "Deutsch"
        },
        "tin": {
            "name": "Mehrwertsteuernummer",
            "type": "MWST/TVA/IVA"
        },
        "flag": "🇨🇭",
        "region": "Europe"
    },
    {
        "country": {
            "code": "CI",
            "code3": "CIV",
            "phoneCode": "225",
            "nameEn": "Côte d'Ivoire",
            "nameLocal": "Côte d'Ivoire",
            "isoNumeric": 384
        },
        "currency": {
            "code": "XOF",
            "nameEn": "CFA franc BCEAO",
            "symbol": "",
            "paypal": "",
            "stripe": ""
        },
        "official": {
            "code": "fr",
            "nameEn": "French",
            "nameLocal": "Français"
        },
        "tin": {
            "name": "",
            "type": ""
        },
        "flag": "🇨🇮",
        "region": "Africa"
    },
    {
        "country": {
            "code": "CL",
            "code3": "CHL",
            "phoneCode": "56",
            "nameEn": "Chile",
            "nameLocal": "Chile",
            "isoNumeric": 152
        },
        "currency": {
            "code": "CLP",
            "nameEn": "Chilean peso",
            "symbol": "",
            "paypal": "0",
            "stripe": "1"
        },
        "official": {
            "code": "es",
            "nameEn": "Spanish, Castilian",
            "nameLocal": "Español"
        },
        "tin": {
            "name": "Rol Único Tributario",
            "type": "RUT"
        },
        "flag": "🇨🇱",
        "region": "South/Latin America"
    },
    {
        "country": {
            "code": "CM",
            "code3": "CMR",
            "phoneCode": "237",
            "nameEn": "Cameroon",
            "nameLocal": "Cameroun, Cameroon",
            "isoNumeric": 120
        },
        "currency": {
            "code": "XAF",
            "nameEn": "CFA franc BEAC",
            "symbol": "FCF",
            "paypal": "",
            "stripe": ""
        },
        "official": {
            "code": "fr",
            "nameEn": "French",
            "nameLocal": "Français"
        },
        "tin": {
            "name": "",
            "type": ""
        },
        "flag": "🇨🇲",
        "region": "Africa"
    },
    {
        "country": {
            "code": "CN",
            "code3": "CHN",
            "phoneCode": "86",
            "nameEn": "China",
            "nameLocal": "中国",
            "isoNumeric": 156
        },
        "currency": {
            "code": "CNY",
            "nameEn": "Renminbi (Chinese) yuan",
            "symbol": "¥",
            "paypal": "0",
            "stripe": "1"
        },
        "official": {
            "code": "zh-hans",
            "nameEn": "",
            "nameLocal": ""
        },
        "tin": {
            "name": "",
            "type": ""
        },
        "flag": "🇨🇳",
        "region": "Asia & Pacific"
    },
    {
        "country": {
            "code": "CO",
            "code3": "COL",
            "phoneCode": "57",
            "nameEn": "Colombia",
            "nameLocal": "Colombia",
            "isoNumeric": 170
        },
        "currency": {
            "code": "COP",
            "nameEn": "Colombian peso",
            "symbol": "$",
            "paypal": "0",
            "stripe": "1"
        },
        "official": {
            "code": "es",
            "nameEn": "Spanish, Castilian",
            "nameLocal": "Español"
        },
        "tin": {
            "name": "Número De Identificación Tributaria",
            "type": "NIT"
        },
        "flag": "🇨🇴",
        "region": "South/Latin America"
    },
    {
        "country": {
            "code": "CR",
            "code3": "CRI",
            "phoneCode": "506",
            "nameEn": "Costa Rica",
            "nameLocal": "Costa Rica",
            "isoNumeric": 188
        },
        "currency": {
            "code": "CRC",
            "nameEn": "Costa Rican colon",
            "symbol": "₡",
            "paypal": "0",
            "stripe": "1"
        },
        "official": {
            "code": "es",
            "nameEn": "Spanish, Castilian",
            "nameLocal": "Español"
        },
        "tin": {
            "name": "Cédula Jurídica",
            "type": ""
        },
        "flag": "🇨🇷",
        "region": "South/Latin America"
    },
    {
        "country": {
            "code": "CU",
            "code3": "CUB",
            "phoneCode": "53",
            "nameEn": "Cuba",
            "nameLocal": "Cuba",
            "isoNumeric": 192
        },
        "currency": {
            "code": "CUC",
            "nameEn": "Cuban convertible peso",
            "symbol": "₱",
            "paypal": "",
            "stripe": ""
        },
        "official": {
            "code": "es",
            "nameEn": "Spanish, Castilian",
            "nameLocal": "Español"
        },
        "tin": {
            "name": "",
            "type": ""
        },
        "flag": "🇨🇺",
        "region": "South/Latin America"
    },
    {
        "country": {
            "code": "CV",
            "code3": "CPV",
            "phoneCode": "238",
            "nameEn": "Cabo Verde",
            "nameLocal": "Cabo Verde",
            "isoNumeric": 132
        },
        "currency": {
            "code": "CVE",
            "nameEn": "Cape Verdean escudo",
            "symbol": "",
            "paypal": "",
            "stripe": ""
        },
        "official": {
            "code": "pt",
            "nameEn": "Portuguese",
            "nameLocal": "Português"
        },
        "tin": {
            "name": "",
            "type": ""
        },
        "flag": "🇨🇻",
        "region": "Africa"
    },
    {
        "country": {
            "code": "CW",
            "code3": "",
            "phoneCode": "599",
            "nameEn": "Curaçao",
            "nameLocal": "Curaçao",
            "isoNumeric": ""
        },
        "currency": {
            "code": "ANG",
            "nameEn": "Netherlands Antillean guilder",
            "symbol": "",
            "paypal": "0",
            "stripe": "1"
        },
        "official": {
            "code": "nl",
            "nameEn": "Dutch, Flemish",
            "nameLocal": "Nederlands, Vlaams"
        },
        "tin": {
            "name": "",
            "type": ""
        },
        "flag": "🇨🇼",
        "region": "Unknown"
    },
    {
        "country": {
            "code": "CX",
            "code3": "CXR",
            "phoneCode": "61",
            "nameEn": "Christmas Island",
            "nameLocal": "Christmas Island",
            "isoNumeric": 162
        },
        "currency": {
            "code": "AUD",
            "nameEn": "Australian dollar",
            "symbol": "$",
            "paypal": "1",
            "stripe": "1"
        },
        "official": {
            "code": "en",
            "nameEn": "English",
            "nameLocal": "English"
        },
        "tin": {
            "name": "",
            "type": ""
        },
        "flag": "🇨🇽",
        "region": "Asia & Pacific"
    },
    {
        "country": {
            "code": "CY",
            "code3": "CYP",
            "phoneCode": "357",
            "nameEn": "Cyprus",
            "nameLocal": "Κύπρος, Kibris",
            "isoNumeric": 196
        },
        "currency": {
            "code": "EUR",
            "nameEn": "Euro",
            "symbol": "€",
            "paypal": "1",
            "stripe": "1"
        },
        "official": {
            "code": "el",
            "nameEn": "Greek, Modern (1453-)",
            "nameLocal": "ελληνικά"
        },
        "tin": {
            "name": "Αριθμός Εγγραφής Φ.Π.Α.",
            "type": "ΦΠΑ"
        },
        "flag": "🇨🇾",
        "region": "Europe"
    },
    {
        "country": {
            "code": "DE",
            "code3": "DEU",
            "phoneCode": "49",
            "nameEn": "Germany",
            "nameLocal": "Deutschland",
            "isoNumeric": 276
        },
        "currency": {
            "code": "EUR",
            "nameEn": "Euro",
            "symbol": "€",
            "paypal": "1",
            "stripe": "1"
        },
        "official": {
            "code": "de",
            "nameEn": "German",
            "nameLocal": "Deutsch"
        },
        "tin": {
            "name": "Umsatzsteuer-Identifikationsnummer",
            "type": "USt-IdNr."
        },
        "flag": "🇩🇪",
        "region": "Europe"
    },
    {
        "country": {
            "code": "DJ",
            "code3": "DJI",
            "phoneCode": "253",
            "nameEn": "Djibouti",
            "nameLocal": "Djibouti, جيبوتي, Jabuuti, Gabuutih",
            "isoNumeric": 262
        },
        "currency": {
            "code": "DJF",
            "nameEn": "Djiboutian franc",
            "symbol": "",
            "paypal": "",
            "stripe": ""
        },
        "official": {
            "code": "fr",
            "nameEn": "French",
            "nameLocal": "Français"
        },
        "tin": {
            "name": "",
            "type": ""
        },
        "flag": "🇩🇯",
        "region": "Arab States"
    },
    {
        "country": {
            "code": "DK",
            "code3": "DNK",
            "phoneCode": "45",
            "nameEn": "Denmark",
            "nameLocal": "Danmark",
            "isoNumeric": 208
        },
        "currency": {
            "code": "DKK",
            "nameEn": "Danish krone",
            "symbol": "kr",
            "paypal": "1",
            "stripe": "1"
        },
        "official": {
            "code": "da",
            "nameEn": "Danish",
            "nameLocal": "dansk"
        },
        "tin": {
            "name": "Momsregistreringsnummer",
            "type": "CVR"
        },
        "flag": "🇩🇰",
        "region": "Europe"
    },
    {
        "country": {
            "code": "DM",
            "code3": "DMA",
            "phoneCode": "767",
            "nameEn": "Dominica",
            "nameLocal": "Dominica",
            "isoNumeric": 212
        },
        "currency": {
            "code": "XCD",
            "nameEn": "East Caribbean dollar",
            "symbol": "$",
            "paypal": "0",
            "stripe": "1"
        },
        "official": {
            "code": "en",
            "nameEn": "English",
            "nameLocal": "English"
        },
        "tin": {
            "name": "",
            "type": ""
        },
        "flag": "🇩🇲",
        "region": "South/Latin America"
    },
    {
        "country": {
            "code": "DZ",
            "code3": "DZA",
            "phoneCode": "213",
            "nameEn": "Algeria",
            "nameLocal": "الجزائر",
            "isoNumeric": 12
        },
        "currency": {
            "code": "DZD",
            "nameEn": "Algerian dinar",
            "symbol": "",
            "paypal": "",
            "stripe": ""
        },
        "official": {
            "code": "ar",
            "nameEn": "Arabic",
            "nameLocal": "العربية"
        },
        "tin": {
            "name": "",
            "type": ""
        },
        "flag": "🇩🇿",
        "region": "Arab States"
    },
    {
        "country": {
            "code": "EC",
            "code3": "ECU",
            "phoneCode": "593",
            "nameEn": "Ecuador",
            "nameLocal": "Ecuador",
            "isoNumeric": 218
        },
        "currency": {
            "code": "USD",
            "nameEn": "United States dollar",
            "symbol": "$",
            "paypal": "1",
            "stripe": "1"
        },
        "official": {
            "code": "es",
            "nameEn": "Spanish, Castilian",
            "nameLocal": "Español"
        },
        "tin": {
            "name": "Número de Registro Unico de Contribuyentes",
            "type": "RUC"
        },
        "flag": "🇪🇨",
        "region": "South/Latin America"
    },
    {
        "country": {
            "code": "EE",
            "code3": "EST",
            "phoneCode": "372",
            "nameEn": "Estonia",
            "nameLocal": "Eesti",
            "isoNumeric": 233
        },
        "currency": {
            "code": "EUR",
            "nameEn": "Euro",
            "symbol": "kr",
            "paypal": "1",
            "stripe": "1"
        },
        "official": {
            "code": "et",
            "nameEn": "Estonian",
            "nameLocal": "eesti, eesti keel"
        },
        "tin": {
            "name": "Käibemaksukohustuslase number",
            "type": "KMKR"
        },
        "flag": "🇪🇪",
        "region": "Europe"
    },
    {
        "country": {
            "code": "EG",
            "code3": "EGY",
            "phoneCode": "20",
            "nameEn": "Egypt",
            "nameLocal": "مصر",
            "isoNumeric": 818
        },
        "currency": {
            "code": "EGP",
            "nameEn": "Egyptian pound",
            "symbol": "£",
            "paypal": "0",
            "stripe": "1"
        },
        "official": {
            "code": "ar",
            "nameEn": "Arabic",
            "nameLocal": "العربية"
        },
        "tin": {
            "name": "",
            "type": ""
        },
        "flag": "🇪🇬",
        "region": "Arab States"
    },
    {
        "country": {
            "code": "EH",
            "code3": "ESH",
            "phoneCode": "212",
            "nameEn": "Western Sahara",
            "nameLocal": "Sahara Occidental",
            "isoNumeric": 732
        },
        "currency": {
            "code": "MAD",
            "nameEn": "Moroccan dirham",
            "symbol": "",
            "paypal": "",
            "stripe": ""
        },
        "official": {
            "code": "ar",
            "nameEn": "Arabic",
            "nameLocal": "العربية"
        },
        "tin": {
            "name": "",
            "type": ""
        },
        "flag": "🇪🇭",
        "region": "Africa"
    },
    {
        "country": {
            "code": "ER",
            "code3": "ERI",
            "phoneCode": "291",
            "nameEn": "Eritrea",
            "nameLocal": "ኤርትራ, إرتريا, Eritrea",
            "isoNumeric": 232
        },
        "currency": {
            "code": "ERN",
            "nameEn": "Eritrean nakfa",
            "symbol": "Nfk",
            "paypal": "",
            "stripe": ""
        },
        "official": {
            "code": "ti",
            "nameEn": "Tigrinya",
            "nameLocal": "ትግርኛ"
        },
        "tin": {
            "name": "",
            "type": ""
        },
        "flag": "🇪🇷",
        "region": "Africa"
    },
    {
        "country": {
            "code": "ES",
            "code3": "ESP",
            "phoneCode": "34",
            "nameEn": "Spain",
            "nameLocal": "España",
            "isoNumeric": 724
        },
        "currency": {
            "code": "EUR",
            "nameEn": "Euro",
            "symbol": "€",
            "paypal": "1",
            "stripe": "1"
        },
        "official": {
            "code": "ast",
            "nameEn": "",
            "nameLocal": ""
        },
        "tin": {
            "name": "Número de Identificación Fiscal (formerly named Código de Identificación Fiscal)",
            "type": "NIF (CIF)"
        },
        "flag": "🇪🇸",
        "region": "Europe"
    },
    {
        "country": {
            "code": "ET",
            "code3": "ETH",
            "phoneCode": "251",
            "nameEn": "Ethiopia",
            "nameLocal": "ኢትዮጵያ, Itoophiyaa",
            "isoNumeric": 231
        },
        "currency": {
            "code": "ETB",
            "nameEn": "Ethiopian birr",
            "symbol": "",
            "paypal": "",
            "stripe": ""
        },
        "official": {
            "code": "am",
            "nameEn": "Amharic",
            "nameLocal": "አማርኛ"
        },
        "tin": {
            "name": "",
            "type": ""
        },
        "flag": "🇪🇹",
        "region": "Africa"
    },
    {
        "country": {
            "code": "FI",
            "code3": "FIN",
            "phoneCode": "358",
            "nameEn": "Finland",
            "nameLocal": "Suomi",
            "isoNumeric": 246
        },
        "currency": {
            "code": "EUR",
            "nameEn": "Euro",
            "symbol": "€",
            "paypal": "1",
            "stripe": "1"
        },
        "official": {
            "code": "fi",
            "nameEn": "Finnish",
            "nameLocal": "suomi, suomen kieli"
        },
        "tin": {
            "name": "Arvonlisäveronumero",
            "type": "ALV nro"
        },
        "flag": "🇫🇮",
        "region": "Europe"
    },
    {
        "country": {
            "code": "FJ",
            "code3": "FJI",
            "phoneCode": "679",
            "nameEn": "Fiji",
            "nameLocal": "Fiji",
            "isoNumeric": 242
        },
        "currency": {
            "code": "FJD",
            "nameEn": "Fiji dollar",
            "symbol": "$",
            "paypal": "0",
            "stripe": "1"
        },
        "official": {
            "code": "en",
            "nameEn": "English",
            "nameLocal": "English"
        },
        "tin": {
            "name": "",
            "type": ""
        },
        "flag": "🇫🇯",
        "region": "Asia & Pacific"
    },
    {
        "country": {
            "code": "FM",
            "code3": "FSM",
            "phoneCode": "691",
            "nameEn": "Micronesia (Federated States of)",
            "nameLocal": "Micronesia",
            "isoNumeric": 583
        },
        "currency": {
            "code": "USD",
            "nameEn": "United States dollar",
            "symbol": "$",
            "paypal": "1",
            "stripe": "1"
        },
        "official": {
            "code": "en",
            "nameEn": "English",
            "nameLocal": "English"
        },
        "tin": {
            "name": "",
            "type": ""
        },
        "flag": "🇫🇲",
        "region": "Asia & Pacific"
    },
    {
        "country": {
            "code": "FR",
            "code3": "FRA",
            "phoneCode": "33",
            "nameEn": "France",
            "nameLocal": "France",
            "isoNumeric": 250
        },
        "currency": {
            "code": "EUR",
            "nameEn": "Euro",
            "symbol": "€",
            "paypal": "1",
            "stripe": "1"
        },
        "official": {
            "code": "fr",
            "nameEn": "French",
            "nameLocal": "Français"
        },
        "tin": {
            "name": "Numéro d'identification à la taxe sur la valeur ajoutée / Numéro de TVA intracommunautaire",
            "type": "n° TVA"
        },
        "flag": "🇫🇷",
        "region": "Europe"
    },
    {
        "country": {
            "code": "GA",
            "code3": "GAB",
            "phoneCode": "241",
            "nameEn": "Gabon",
            "nameLocal": "Gabon",
            "isoNumeric": 266
        },
        "currency": {
            "code": "XAF",
            "nameEn": "CFA franc BEAC",
            "symbol": "FCF",
            "paypal": "",
            "stripe": ""
        },
        "official": {
            "code": "fr",
            "nameEn": "French",
            "nameLocal": "Français"
        },
        "tin": {
            "name": "",
            "type": ""
        },
        "flag": "🇬🇦",
        "region": "Africa"
    },
    {
        "country": {
            "code": "GD",
            "code3": "GRD",
            "phoneCode": "1473",
            "nameEn": "Grenada",
            "nameLocal": "Grenada",
            "isoNumeric": 308
        },
        "currency": {
            "code": "XCD",
            "nameEn": "East Caribbean dollar",
            "symbol": "$",
            "paypal": "0",
            "stripe": "1"
        },
        "official": {
            "code": "en",
            "nameEn": "English",
            "nameLocal": "English"
        },
        "tin": {
            "name": "",
            "type": ""
        },
        "flag": "🇬🇩",
        "region": "South/Latin America"
    },
    {
        "country": {
            "code": "GE",
            "code3": "GEO",
            "phoneCode": "995",
            "nameEn": "Georgia",
            "nameLocal": "საქართველო",
            "isoNumeric": 268
        },
        "currency": {
            "code": "GEL",
            "nameEn": "Georgian lari",
            "symbol": "",
            "paypal": "",
            "stripe": ""
        },
        "official": {
            "code": "ka",
            "nameEn": "Georgian",
            "nameLocal": "ქართული"
        },
        "tin": {
            "name": "",
            "type": ""
        },
        "flag": "🇬🇪",
        "region": "Europe"
    },
    {
        "country": {
            "code": "GF",
            "code3": "GUF",
            "phoneCode": "594",
            "nameEn": "French Guiana",
            "nameLocal": "Guyane française",
            "isoNumeric": 254
        },
        "currency": {
            "code": "EUR",
            "nameEn": "Euro",
            "symbol": "€",
            "paypal": "1",
            "stripe": "1"
        },
        "official": {
            "code": "fr",
            "nameEn": "French",
            "nameLocal": "Français"
        },
        "tin": {
            "name": "",
            "type": ""
        },
        "flag": "🇬🇫",
        "region": "South/Latin America"
    },
    {
        "country": {
            "code": "GG",
            "code3": "",
            "phoneCode": "44",
            "nameEn": "Guernsey",
            "nameLocal": "Guernsey",
            "isoNumeric": ""
        },
        "currency": {
            "code": "GBP",
            "nameEn": "Pound sterling",
            "symbol": "",
            "paypal": "1",
            "stripe": "1"
        },
        "official": {
            "code": "en",
            "nameEn": "English",
            "nameLocal": "English"
        },
        "tin": {
            "name": "",
            "type": ""
        },
        "flag": "🇬🇬",
        "region": "Europe"
    },
    {
        "country": {
            "code": "GH",
            "code3": "GHA",
            "phoneCode": "233",
            "nameEn": "Ghana",
            "nameLocal": "Ghana",
            "isoNumeric": 288
        },
        "currency": {
            "code": "GHS",
            "nameEn": "Ghanaian cedi",
            "symbol": "¢",
            "paypal": "",
            "stripe": ""
        },
        "official": {
            "code": "en",
            "nameEn": "English",
            "nameLocal": "English"
        },
        "tin": {
            "name": "",
            "type": ""
        },
        "flag": "🇬🇭",
        "region": "Africa"
    },
    {
        "country": {
            "code": "GI",
            "code3": "GIB",
            "phoneCode": "350",
            "nameEn": "Gibraltar",
            "nameLocal": "Gibraltar",
            "isoNumeric": 292
        },
        "currency": {
            "code": "GIP",
            "nameEn": "Gibraltar pound",
            "symbol": "£",
            "paypal": "0",
            "stripe": "1"
        },
        "official": {
            "code": "en",
            "nameEn": "English",
            "nameLocal": "English"
        },
        "tin": {
            "name": "",
            "type": ""
        },
        "flag": "🇬🇮",
        "region": "Europe"
    },
    {
        "country": {
            "code": "GL",
            "code3": "GRL",
            "phoneCode": "299",
            "nameEn": "Greenland",
            "nameLocal": "Kalaallit Nunaat, Grønland",
            "isoNumeric": 304
        },
        "currency": {
            "code": "DKK",
            "nameEn": "Danish krone",
            "symbol": "kr",
            "paypal": "1",
            "stripe": "1"
        },
        "official": {
            "code": "kl",
            "nameEn": "Kalaallisut, Greenlandic",
            "nameLocal": "kalaallisut, kalaallit oqaasii"
        },
        "tin": {
            "name": "",
            "type": ""
        },
        "flag": "🇬🇱",
        "region": "Europe"
    },
    {
        "country": {
            "code": "GN",
            "code3": "GIN",
            "phoneCode": "224",
            "nameEn": "Guinea",
            "nameLocal": "Guinée",
            "isoNumeric": 324
        },
        "currency": {
            "code": "GNF",
            "nameEn": "Guinean franc",
            "symbol": "",
            "paypal": "",
            "stripe": ""
        },
        "official": {
            "code": "fr",
            "nameEn": "French",
            "nameLocal": "Français"
        },
        "tin": {
            "name": "",
            "type": ""
        },
        "flag": "🇬🇳",
        "region": "Africa"
    },
    {
        "country": {
            "code": "GP",
            "code3": "GLP",
            "phoneCode": "590",
            "nameEn": "Guadeloupe",
            "nameLocal": "Guadeloupe",
            "isoNumeric": 312
        },
        "currency": {
            "code": "EUR",
            "nameEn": "Euro",
            "symbol": "€",
            "paypal": "1",
            "stripe": "1"
        },
        "official": {
            "code": "fr",
            "nameEn": "French",
            "nameLocal": "Français"
        },
        "tin": {
            "name": "",
            "type": ""
        },
        "flag": "🇬🇵",
        "region": "South/Latin America"
    },
    {
        "country": {
            "code": "GQ",
            "code3": "GNQ",
            "phoneCode": "240",
            "nameEn": "Equatorial Guinea",
            "nameLocal": "Guiena ecuatorial, Guinée équatoriale, Guiné Equatorial",
            "isoNumeric": 226
        },
        "currency": {
            "code": "XAF",
            "nameEn": "CFA franc BEAC",
            "symbol": "FCF",
            "paypal": "",
            "stripe": ""
        },
        "official": {
            "code": "es",
            "nameEn": "Spanish, Castilian",
            "nameLocal": "Español"
        },
        "tin": {
            "name": "",
            "type": ""
        },
        "flag": "🇬🇶",
        "region": "Africa"
    },
    {
        "country": {
            "code": "GR",
            "code3": "GRC",
            "phoneCode": "30",
            "nameEn": "Greece",
            "nameLocal": "Ελλάδα",
            "isoNumeric": 300
        },
        "currency": {
            "code": "EUR",
            "nameEn": "Euro",
            "symbol": "€",
            "paypal": "1",
            "stripe": "1"
        },
        "official": {
            "code": "el",
            "nameEn": "Greek, Modern (1453-)",
            "nameLocal": "ελληνικά"
        },
        "tin": {
            "name": "",
            "type": ""
        },
        "flag": "🇬🇷",
        "region": "Europe"
    },
    {
        "country": {
            "code": "GS",
            "code3": "SGS",
            "phoneCode": "500",
            "nameEn": "South Georgia and the South Sandwich Islands",
            "nameLocal": "South Georgia and the South Sandwich Islands",
            "isoNumeric": 239
        },
        "currency": {
            "code": "",
            "nameEn": "",
            "symbol": "£",
            "paypal": "",
            "stripe": ""
        },
        "official": {
            "code": "en",
            "nameEn": "English",
            "nameLocal": "English"
        },
        "tin": {
            "name": "",
            "type": ""
        },
        "flag": "🇬🇸",
        "region": "South/Latin America"
    },
    {
        "country": {
            "code": "GT",
            "code3": "GTM",
            "phoneCode": "502",
            "nameEn": "Guatemala",
            "nameLocal": "Guatemala",
            "isoNumeric": 320
        },
        "currency": {
            "code": "GTQ",
            "nameEn": "Guatemalan quetzal",
            "symbol": "Q",
            "paypal": "0",
            "stripe": "1"
        },
        "official": {
            "code": "es",
            "nameEn": "Spanish, Castilian",
            "nameLocal": "Español"
        },
        "tin": {
            "name": "Número de Identificación Tributaria",
            "type": "NIT"
        },
        "flag": "🇬🇹",
        "region": "South/Latin America"
    },
    {
        "country": {
            "code": "GU",
            "code3": "GUM",
            "phoneCode": "1",
            "nameEn": "Guam",
            "nameLocal": "Guam, Guåhån",
            "isoNumeric": 316
        },
        "currency": {
            "code": "USD",
            "nameEn": "United States dollar",
            "symbol": "$",
            "paypal": "1",
            "stripe": "1"
        },
        "official": {
            "code": "en",
            "nameEn": "English",
            "nameLocal": "English"
        },
        "tin": {
            "name": "",
            "type": ""
        },
        "flag": "🇬🇺",
        "region": "Asia & Pacific"
    },
    {
        "country": {
            "code": "GW",
            "code3": "GNB",
            "phoneCode": "245",
            "nameEn": "Guinea-Bissau",
            "nameLocal": "Guiné-Bissau",
            "isoNumeric": 624
        },
        "currency": {
            "code": "XOF",
            "nameEn": "CFA franc BCEAO",
            "symbol": "",
            "paypal": "",
            "stripe": ""
        },
        "official": {
            "code": "pt",
            "nameEn": "Portuguese",
            "nameLocal": "Português"
        },
        "tin": {
            "name": "",
            "type": ""
        },
        "flag": "🇬🇼",
        "region": "Africa"
    },
    {
        "country": {
            "code": "GY",
            "code3": "GUY",
            "phoneCode": "592",
            "nameEn": "Guyana",
            "nameLocal": "Guyana",
            "isoNumeric": 328
        },
        "currency": {
            "code": "GYD",
            "nameEn": "Guyanese dollar",
            "symbol": "$",
            "paypal": "0",
            "stripe": "1"
        },
        "official": {
            "code": "en",
            "nameEn": "English",
            "nameLocal": "English"
        },
        "tin": {
            "name": "",
            "type": ""
        },
        "flag": "🇬🇾",
        "region": "South/Latin America"
    },
    {
        "country": {
            "code": "HK",
            "code3": "HKG",
            "phoneCode": "852",
            "nameEn": "Hong Kong",
            "nameLocal": "香港, Hong Kong",
            "isoNumeric": 344
        },
        "currency": {
            "code": "HKD",
            "nameEn": "Hong Kong dollar",
            "symbol": "$",
            "paypal": "1",
            "stripe": "1"
        },
        "official": {
            "code": "zh-hant",
            "nameEn": "",
            "nameLocal": ""
        },
        "tin": {
            "name": "",
            "type": ""
        },
        "flag": "🇭🇰",
        "region": "Asia & Pacific"
    },
    {
        "country": {
            "code": "HN",
            "code3": "HND",
            "phoneCode": "504",
            "nameEn": "Honduras",
            "nameLocal": "Honduras",
            "isoNumeric": 340
        },
        "currency": {
            "code": "HNL",
            "nameEn": "Honduran lempira",
            "symbol": "L",
            "paypal": "0",
            "stripe": "1"
        },
        "official": {
            "code": "es",
            "nameEn": "Spanish, Castilian",
            "nameLocal": "Español"
        },
        "tin": {
            "name": "Registro Tributario Nacional",
            "type": "RTN"
        },
        "flag": "🇭🇳",
        "region": "South/Latin America"
    },
    {
        "country": {
            "code": "HR",
            "code3": "HRV",
            "phoneCode": "385",
            "nameEn": "Croatia",
            "nameLocal": "Hrvatska",
            "isoNumeric": 191
        },
        "currency": {
            "code": "HRK",
            "nameEn": "Croatian kuna",
            "symbol": "kn",
            "paypal": "0",
            "stripe": "1"
        },
        "official": {
            "code": "hr",
            "nameEn": "Croatian",
            "nameLocal": "hrvatski jezik"
        },
        "tin": {
            "name": "PDV Id. Broj OIB",
            "type": "PDV-ID; OIB"
        },
        "flag": "🇭🇷",
        "region": "Europe"
    },
    {
        "country": {
            "code": "HT",
            "code3": "HTI",
            "phoneCode": "509",
            "nameEn": "Haiti",
            "nameLocal": "Haïti, Ayiti",
            "isoNumeric": 332
        },
        "currency": {
            "code": "HTG",
            "nameEn": "Haitian gourde",
            "symbol": "G",
            "paypal": "",
            "stripe": ""
        },
        "official": {
            "code": "fr",
            "nameEn": "French",
            "nameLocal": "Français"
        },
        "tin": {
            "name": "",
            "type": ""
        },
        "flag": "🇭🇹",
        "region": "South/Latin America"
    },
    {
        "country": {
            "code": "HU",
            "code3": "HUN",
            "phoneCode": "36",
            "nameEn": "Hungary",
            "nameLocal": "Magyarország",
            "isoNumeric": 348
        },
        "currency": {
            "code": "HUF",
            "nameEn": "Hungarian forint",
            "symbol": "Ft",
            "paypal": "1",
            "stripe": "1"
        },
        "official": {
            "code": "hu",
            "nameEn": "Hungarian",
            "nameLocal": "magyar"
        },
        "tin": {
            "name": "Közösségi adószám",
            "type": "ANUM"
        },
        "flag": "🇭🇺",
        "region": "Europe"
    },
    {
        "country": {
            "code": "ID",
            "code3": "IDN",
            "phoneCode": "62",
            "nameEn": "Indonesia",
            "nameLocal": "Indonesia",
            "isoNumeric": 360
        },
        "currency": {
            "code": "IDR",
            "nameEn": "Indonesian rupiah",
            "symbol": "Rp",
            "paypal": "0",
            "stripe": "1"
        },
        "official": {
            "code": "id",
            "nameEn": "Indonesian",
            "nameLocal": "Bahasa Indonesia"
        },
        "tin": {
            "name": "Nomor Pokok Wajib Pajak",
            "type": "NPWP"
        },
        "flag": "🇮🇩",
        "region": "Asia & Pacific"
    },
    {
        "country": {
            "code": "IE",
            "code3": "IRL",
            "phoneCode": "353",
            "nameEn": "Ireland",
            "nameLocal": "Ireland, Éire",
            "isoNumeric": 372
        },
        "currency": {
            "code": "EUR",
            "nameEn": "Euro",
            "symbol": "€",
            "paypal": "1",
            "stripe": "1"
        },
        "official": {
            "code": "en",
            "nameEn": "English",
            "nameLocal": "English"
        },
        "tin": {
            "name": "Value added tax identification no.",
            "type": "VAT or CBL"
        },
        "flag": "🇮🇪",
        "region": "Europe"
    },
    {
        "country": {
            "code": "IL",
            "code3": "ISR",
            "phoneCode": "972",
            "nameEn": "Israel",
            "nameLocal": "ישראל",
            "isoNumeric": 376
        },
        "currency": {
            "code": "ILS",
            "nameEn": "Israeli new shekel",
            "symbol": "₪",
            "paypal": "1",
            "stripe": "1"
        },
        "official": {
            "code": "he",
            "nameEn": "Hebrew",
            "nameLocal": "עברית"
        },
        "tin": {
            "name": "מס' עוסק מורשה / ח'פ",
            "type": ""
        },
        "flag": "🇮🇱",
        "region": "Europe"
    },
    {
        "country": {
            "code": "IM",
            "code3": "",
            "phoneCode": "44",
            "nameEn": "Isle of Man",
            "nameLocal": "Isle of Man",
            "isoNumeric": ""
        },
        "currency": {
            "code": "GBP",
            "nameEn": "Pound sterling",
            "symbol": "",
            "paypal": "1",
            "stripe": "1"
        },
        "official": {
            "code": "en",
            "nameEn": "English",
            "nameLocal": "English"
        },
        "tin": {
            "name": "",
            "type": ""
        },
        "flag": "🇮🇲",
        "region": "Europe"
    },
    {
        "country": {
            "code": "IN",
            "code3": "IND",
            "phoneCode": "91",
            "nameEn": "India",
            "nameLocal": "भारत, India",
            "isoNumeric": 356
        },
        "currency": {
            "code": "INR",
            "nameEn": "Indian rupee",
            "symbol": "₹",
            "paypal": "1",
            "stripe": "1"
        },
        "official": {
            "code": "hi",
            "nameEn": "Hindi",
            "nameLocal": "हिन्दी, हिंदी"
        },
        "tin": {
            "name": "Value Added Tax - Taxpayer Identification Number / Central Sales Tax - Taxpayer Identification Number (In most states)Not applicable",
            "type": "VAT TIN / CST TIN"
        },
        "flag": "🇮🇳",
        "region": "Asia & Pacific"
    },
    {
        "country": {
            "code": "IQ",
            "code3": "IRQ",
            "phoneCode": "964",
            "nameEn": "Iraq",
            "nameLocal": "العراق, Iraq",
            "isoNumeric": 368
        },
        "currency": {
            "code": "IQD",
            "nameEn": "Iraqi dinar",
            "symbol": "",
            "paypal": "",
            "stripe": ""
        },
        "official": {
            "code": "ar",
            "nameEn": "Arabic",
            "nameLocal": "العربية"
        },
        "tin": {
            "name": "",
            "type": ""
        },
        "flag": "🇮🇶",
        "region": "Arab States"
    },
    {
        "country": {
            "code": "IR",
            "code3": "IRN",
            "phoneCode": "98",
            "nameEn": "Iran (Islamic Republic of)",
            "nameLocal": "ایران",
            "isoNumeric": 364
        },
        "currency": {
            "code": "IRR",
            "nameEn": "Iranian rial",
            "symbol": "﷼",
            "paypal": "0",
            "stripe": "0"
        },
        "official": {
            "code": "fa",
            "nameEn": "Persian",
            "nameLocal": "فارسی"
        },
        "tin": {
            "name": "",
            "type": ""
        },
        "flag": "🇮🇷",
        "region": "Asia & Pacific"
    },
    {
        "country": {
            "code": "IS",
            "code3": "ISL",
            "phoneCode": "354",
            "nameEn": "Iceland",
            "nameLocal": "Ísland",
            "isoNumeric": 352
        },
        "currency": {
            "code": "ISK",
            "nameEn": "Icelandic króna",
            "symbol": "kr",
            "paypal": "0",
            "stripe": "1"
        },
        "official": {
            "code": "is",
            "nameEn": "Icelandic",
            "nameLocal": "Íslenska"
        },
        "tin": {
            "name": "Virðisaukaskattsnúmer",
            "type": "VSK / VASK"
        },
        "flag": "🇮🇸",
        "region": "Europe"
    },
    {
        "country": {
            "code": "IT",
            "code3": "ITA",
            "phoneCode": "39",
            "nameEn": "Italy",
            "nameLocal": "Italia",
            "isoNumeric": 380
        },
        "currency": {
            "code": "EUR",
            "nameEn": "Euro",
            "symbol": "€",
            "paypal": "1",
            "stripe": "1"
        },
        "official": {
            "code": "it",
            "nameEn": "Italian",
            "nameLocal": "Italiano"
        },
        "tin": {
            "name": "Partita IVA(IVA = Imposta sul Valore Aggiunto)",
            "type": "P.IVA"
        },
        "flag": "🇮🇹",
        "region": "Europe"
    },
    {
        "country": {
            "code": "JE",
            "code3": "",
            "phoneCode": "44",
            "nameEn": "Jersey",
            "nameLocal": "Jersey",
            "isoNumeric": ""
        },
        "currency": {
            "code": "GBP",
            "nameEn": "Pound sterling",
            "symbol": "",
            "paypal": "1",
            "stripe": "1"
        },
        "official": {
            "code": "en",
            "nameEn": "English",
            "nameLocal": "English"
        },
        "tin": {
            "name": "",
            "type": ""
        },
        "flag": "🇯🇪",
        "region": "Europe"
    },
    {
        "country": {
            "code": "JM",
            "code3": "JAM",
            "phoneCode": "876",
            "nameEn": "Jamaica",
            "nameLocal": "Jamaica",
            "isoNumeric": 388
        },
        "currency": {
            "code": "JMD",
            "nameEn": "Jamaican dollar",
            "symbol": "$",
            "paypal": "0",
            "stripe": "1"
        },
        "official": {
            "code": "en",
            "nameEn": "English",
            "nameLocal": "English"
        },
        "tin": {
            "name": "",
            "type": ""
        },
        "flag": "🇯🇲",
        "region": "South/Latin America"
    },
    {
        "country": {
            "code": "JO",
            "code3": "JOR",
            "phoneCode": "962",
            "nameEn": "Jordan",
            "nameLocal": "الأُرْدُن",
            "isoNumeric": 400
        },
        "currency": {
            "code": "JOD",
            "nameEn": "Jordanian dinar",
            "symbol": "",
            "paypal": "",
            "stripe": ""
        },
        "official": {
            "code": "ar",
            "nameEn": "Arabic",
            "nameLocal": "العربية"
        },
        "tin": {
            "name": "",
            "type": ""
        },
        "flag": "🇯🇴",
        "region": "Arab States"
    },
    {
        "country": {
            "code": "JP",
            "code3": "JPN",
            "phoneCode": "81",
            "nameEn": "Japan",
            "nameLocal": "日本",
            "isoNumeric": 392
        },
        "currency": {
            "code": "JPY",
            "nameEn": "Japanese yen",
            "symbol": "¥",
            "paypal": "1",
            "stripe": "1"
        },
        "official": {
            "code": "ja",
            "nameEn": "Japanese",
            "nameLocal": "日本語 (にほんご)"
        },
        "tin": {
            "name": "",
            "type": ""
        },
        "flag": "🇯🇵",
        "region": "Asia & Pacific"
    },
    {
        "country": {
            "code": "KE",
            "code3": "KEN",
            "phoneCode": "254",
            "nameEn": "Kenya",
            "nameLocal": "Kenya",
            "isoNumeric": 404
        },
        "currency": {
            "code": "KES",
            "nameEn": "Kenyan shilling",
            "symbol": "",
            "paypal": "",
            "stripe": ""
        },
        "official": {
            "code": "sw",
            "nameEn": "Swahili",
            "nameLocal": "Kiswahili"
        },
        "tin": {
            "name": "",
            "type": ""
        },
        "flag": "🇰🇪",
        "region": "Africa"
    },
    {
        "country": {
            "code": "KG",
            "code3": "KGZ",
            "phoneCode": "996",
            "nameEn": "Kyrgyzstan",
            "nameLocal": "Кыргызстан, Киргизия",
            "isoNumeric": 417
        },
        "currency": {
            "code": "KGS",
            "nameEn": "Kyrgyzstani som",
            "symbol": "лв",
            "paypal": "0",
            "stripe": "1"
        },
        "official": {
            "code": "ky",
            "nameEn": "Kirghiz, Kyrgyz",
            "nameLocal": "Кыргызча, Кыргыз тили"
        },
        "tin": {
            "name": "",
            "type": ""
        },
        "flag": "🇰🇬",
        "region": "Asia & Pacific"
    },
    {
        "country": {
            "code": "KH",
            "code3": "KHM",
            "phoneCode": "855",
            "nameEn": "Cambodia",
            "nameLocal": "កម្ពុជា",
            "isoNumeric": 116
        },
        "currency": {
            "code": "KHR",
            "nameEn": "Cambodian riel",
            "symbol": "៛",
            "paypal": "0",
            "stripe": "1"
        },
        "official": {
            "code": "km",
            "nameEn": "Central Khmer",
            "nameLocal": "ខ្មែរ, ខេមរភាសា, ភាសាខ្មែរ"
        },
        "tin": {
            "name": "",
            "type": ""
        },
        "flag": "🇰🇭",
        "region": "Asia & Pacific"
    },
    {
        "country": {
            "code": "KP",
            "code3": "PRK",
            "phoneCode": "850",
            "nameEn": "North Korea",
            "nameLocal": "조선민주주의인민공화국",
            "isoNumeric": 408
        },
        "currency": {
            "code": "KPW",
            "nameEn": "North Korean won",
            "symbol": "₩",
            "paypal": "0",
            "stripe": "0"
        },
        "official": {
            "code": "ko",
            "nameEn": "Korean",
            "nameLocal": "조선어"
        },
        "tin": {
            "name": "",
            "type": ""
        },
        "flag": "🇰🇵",
        "region": "Asia"
    },
    {
        "country": {
            "code": "KR",
            "code3": "KOR",
            "phoneCode": "82",
            "nameEn": "South Korea",
            "nameLocal": "대한민국",
            "isoNumeric": 410
        },
        "currency": {
            "code": "KRW",
            "nameEn": "South Korean won",
            "symbol": "₩",
            "paypal": "0",
            "stripe": "1"
        },
        "official": {
            "code": "ko",
            "nameEn": "Korean",
            "nameLocal": "한국어"
        },
        "tin": {
            "name": "",
            "type": ""
        },
        "flag": "🇰🇷",
        "region": "Asia"
    },
    {
        "country": {
            "code": "KI",
            "code3": "KIR",
            "phoneCode": "686",
            "nameEn": "Kiribati",
            "nameLocal": "Kiribati",
            "isoNumeric": 296
        },
        "currency": {
            "code": "AUD",
            "nameEn": "Australian dollar",
            "symbol": "$",
            "paypal": "1",
            "stripe": "1"
        },
        "official": {
            "code": "en",
            "nameEn": "English",
            "nameLocal": "English"
        },
        "tin": {
            "name": "",
            "type": ""
        },
        "flag": "🇰🇮",
        "region": "Asia & Pacific"
    },
    {
        "country": {
            "code": "KN",
            "code3": "KNA",
            "phoneCode": "1869",
            "nameEn": "Saint Kitts and Nevis",
            "nameLocal": "Saint Kitts and Nevis",
            "isoNumeric": 659
        },
        "currency": {
            "code": "XCD",
            "nameEn": "East Caribbean dollar",
            "symbol": "$",
            "paypal": "0",
            "stripe": "1"
        },
        "official": {
            "code": "en",
            "nameEn": "English",
            "nameLocal": "English"
        },
        "tin": {
            "name": "",
            "type": ""
        },
        "flag": "🇰🇳",
        "region": "South/Latin America"
    },
    {
        "country": {
            "code": "KW",
            "code3": "KWT",
            "phoneCode": "965",
            "nameEn": "Kuwait",
            "nameLocal": "الكويت",
            "isoNumeric": 414
        },
        "currency": {
            "code": "KWD",
            "nameEn": "Kuwaiti dinar",
            "symbol": "",
            "paypal": "",
            "stripe": ""
        },
        "official": {
            "code": "ar",
            "nameEn": "Arabic",
            "nameLocal": "العربية"
        },
        "tin": {
            "name": "",
            "type": ""
        },
        "flag": "🇰🇼",
        "region": "Arab States"
    },
    {
        "country": {
            "code": "KZ",
            "code3": "KAZ",
            "phoneCode": "7",
            "nameEn": "Kazakhstan",
            "nameLocal": "Қазақстан, Казахстан",
            "isoNumeric": 398
        },
        "currency": {
            "code": "KZT",
            "nameEn": "Kazakhstani tenge",
            "symbol": "лв",
            "paypal": "0",
            "stripe": "1"
        },
        "official": {
            "code": "kk",
            "nameEn": "Kazakh",
            "nameLocal": "қазақ тілі"
        },
        "tin": {
            "name": "",
            "type": ""
        },
        "flag": "🇰🇿",
        "region": "Asia & Pacific"
    },
    {
        "country": {
            "code": "LB",
            "code3": "LBN",
            "phoneCode": "961",
            "nameEn": "Lebanon",
            "nameLocal": "لبنان, Liban",
            "isoNumeric": 422
        },
        "currency": {
            "code": "LBP",
            "nameEn": "Lebanese pound",
            "symbol": "£",
            "paypal": "0",
            "stripe": "1"
        },
        "official": {
            "code": "ar",
            "nameEn": "Arabic",
            "nameLocal": "العربية"
        },
        "tin": {
            "name": "",
            "type": ""
        },
        "flag": "🇱🇧",
        "region": "Arab States"
    },
    {
        "country": {
            "code": "LC",
            "code3": "LCA",
            "phoneCode": "1758",
            "nameEn": "Saint Lucia",
            "nameLocal": "Saint Lucia",
            "isoNumeric": 662
        },
        "currency": {
            "code": "XCD",
            "nameEn": "East Caribbean dollar",
            "symbol": "$",
            "paypal": "0",
            "stripe": "1"
        },
        "official": {
            "code": "en",
            "nameEn": "English",
            "nameLocal": "English"
        },
        "tin": {
            "name": "",
            "type": ""
        },
        "flag": "🇱🇨",
        "region": "South/Latin America"
    },
    {
        "country": {
            "code": "LI",
            "code3": "LIE",
            "phoneCode": "423",
            "nameEn": "Liechtenstein",
            "nameLocal": "Liechtenstein",
            "isoNumeric": 438
        },
        "currency": {
            "code": "CHF",
            "nameEn": "Swiss franc",
            "symbol": "CHF",
            "paypal": "1",
            "stripe": "1"
        },
        "official": {
            "code": "de",
            "nameEn": "German",
            "nameLocal": "Deutsch"
        },
        "tin": {
            "name": "",
            "type": ""
        },
        "flag": "🇱🇮",
        "region": "Europe"
    },
    {
        "country": {
            "code": "LK",
            "code3": "LKA",
            "phoneCode": "94",
            "nameEn": "Sri Lanka",
            "nameLocal": "ශ්‍රී ලංකා, இலங்கை",
            "isoNumeric": 144
        },
        "currency": {
            "code": "LKR",
            "nameEn": "Sri Lankan rupee",
            "symbol": "₨",
            "paypal": "0",
            "stripe": "1"
        },
        "official": {
            "code": "si",
            "nameEn": "Sinhala, Sinhalese",
            "nameLocal": "සිංහල"
        },
        "tin": {
            "name": "",
            "type": ""
        },
        "flag": "🇱🇰",
        "region": "Asia & Pacific"
    },
    {
        "country": {
            "code": "LR",
            "code3": "LBR",
            "phoneCode": "231",
            "nameEn": "Liberia",
            "nameLocal": "Liberia",
            "isoNumeric": 430
        },
        "currency": {
            "code": "LRD",
            "nameEn": "Liberian dollar",
            "symbol": "$",
            "paypal": "0",
            "stripe": "1"
        },
        "official": {
            "code": "en",
            "nameEn": "English",
            "nameLocal": "English"
        },
        "tin": {
            "name": "",
            "type": ""
        },
        "flag": "🇱🇷",
        "region": "Africa"
    },
    {
        "country": {
            "code": "LS",
            "code3": "LSO",
            "phoneCode": "266",
            "nameEn": "Lesotho",
            "nameLocal": "Lesotho",
            "isoNumeric": 426
        },
        "currency": {
            "code": "LSL",
            "nameEn": "Lesotho loti",
            "symbol": "L",
            "paypal": "",
            "stripe": ""
        },
        "official": {
            "code": "en",
            "nameEn": "English",
            "nameLocal": "English"
        },
        "tin": {
            "name": "",
            "type": ""
        },
        "flag": "🇱🇸",
        "region": "Africa"
    },
    {
        "country": {
            "code": "LT",
            "code3": "LTU",
            "phoneCode": "370",
            "nameEn": "Lithuania",
            "nameLocal": "Lietuva",
            "isoNumeric": 440
        },
        "currency": {
            "code": "EUR",
            "nameEn": "Euro",
            "symbol": "Lt",
            "paypal": "1",
            "stripe": "1"
        },
        "official": {
            "code": "lt",
            "nameEn": "Lithuanian",
            "nameLocal": "lietuvių kalba"
        },
        "tin": {
            "name": "PVM (abbrev. Pridėtinės vertės mokestis) mokėtojo kodas",
            "type": "PVM kodas"
        },
        "flag": "🇱🇹",
        "region": "Europe"
    },
    {
        "country": {
            "code": "LU",
            "code3": "LUX",
            "phoneCode": "352",
            "nameEn": "Luxembourg",
            "nameLocal": "Lëtzebuerg, Luxembourg, Luxemburg",
            "isoNumeric": 442
        },
        "currency": {
            "code": "EUR",
            "nameEn": "Euro",
            "symbol": "€",
            "paypal": "1",
            "stripe": "1"
        },
        "official": {
            "code": "lb",
            "nameEn": "Luxembourgish, Letzeburgesch",
            "nameLocal": "Lëtzebuergesch"
        },
        "tin": {
            "name": "Numéro d'identification à la taxe sur la valeur ajoutée",
            "type": "No. TVA"
        },
        "flag": "🇱🇺",
        "region": "Europe"
    },
    {
        "country": {
            "code": "LV",
            "code3": "LVA",
            "phoneCode": "371",
            "nameEn": "Latvia",
            "nameLocal": "Latvija",
            "isoNumeric": 428
        },
        "currency": {
            "code": "EUR",
            "nameEn": "Euro",
            "symbol": "Ls",
            "paypal": "1",
            "stripe": "1"
        },
        "official": {
            "code": "lv",
            "nameEn": "Latvian",
            "nameLocal": "latviešu valoda"
        },
        "tin": {
            "name": "Pievienotās vērtības nodokļa (PVN) reģistrācijas numurs",
            "type": "PVN"
        },
        "flag": "🇱🇻",
        "region": "Europe"
    },
    {
        "country": {
            "code": "LY",
            "code3": "LBY",
            "phoneCode": "218",
            "nameEn": "Libya",
            "nameLocal": "ليبيا",
            "isoNumeric": 434
        },
        "currency": {
            "code": "LYD",
            "nameEn": "Libyan dinar",
            "symbol": "",
            "paypal": "",
            "stripe": ""
        },
        "official": {
            "code": "ar",
            "nameEn": "Arabic",
            "nameLocal": "العربية"
        },
        "tin": {
            "name": "",
            "type": ""
        },
        "flag": "🇱🇾",
        "region": "Arab States"
    },
    {
        "country": {
            "code": "MA",
            "code3": "MAR",
            "phoneCode": "212",
            "nameEn": "Morocco",
            "nameLocal": "Maroc, ⵍⵎⵖⵔⵉⴱ, المغرب",
            "isoNumeric": 504
        },
        "currency": {
            "code": "MAD",
            "nameEn": "Moroccan dirham",
            "symbol": "",
            "paypal": "",
            "stripe": ""
        },
        "official": {
            "code": "fr",
            "nameEn": "French",
            "nameLocal": "Français"
        },
        "tin": {
            "name": "",
            "type": ""
        },
        "flag": "🇲🇦",
        "region": "Arab States"
    },
    {
        "country": {
            "code": "MC",
            "code3": "MCO",
            "phoneCode": "377",
            "nameEn": "Monaco",
            "nameLocal": "Monaco",
            "isoNumeric": 492
        },
        "currency": {
            "code": "EUR",
            "nameEn": "Euro",
            "symbol": "€",
            "paypal": "1",
            "stripe": "1"
        },
        "official": {
            "code": "fr",
            "nameEn": "French",
            "nameLocal": "Français"
        },
        "tin": {
            "name": "",
            "type": ""
        },
        "flag": "🇲🇨",
        "region": "Europe"
    },
    {
        "country": {
            "code": "ME",
            "code3": "",
            "phoneCode": "382",
            "nameEn": "Montenegro",
            "nameLocal": "Crna Gora, Црна Гора",
            "isoNumeric": ""
        },
        "currency": {
            "code": "EUR",
            "nameEn": "Euro",
            "symbol": "",
            "paypal": "1",
            "stripe": "1"
        },
        "official": {
            "code": "srp",
            "nameEn": "српски језик",
            "nameLocal": ""
        },
        "tin": {
            "name": "",
            "type": ""
        },
        "flag": "🇲🇪",
        "region": "Europe"
    },
    {
        "country": {
            "code": "MF",
            "code3": "",
            "phoneCode": "590",
            "nameEn": "Saint Martin (French part)",
            "nameLocal": "Saint-Martin",
            "isoNumeric": ""
        },
        "currency": {
            "code": "EUR",
            "nameEn": "Euro",
            "symbol": "",
            "paypal": "1",
            "stripe": "1"
        },
        "official": {
            "code": "fr",
            "nameEn": "French",
            "nameLocal": "Français"
        },
        "tin": {
            "name": "",
            "type": ""
        },
        "flag": "🇲🇫",
        "region": "South/Latin America"
    },
    {
        "country": {
            "code": "MG",
            "code3": "MDG",
            "phoneCode": "261",
            "nameEn": "Madagascar",
            "nameLocal": "Madagasikara, Madagascar",
            "isoNumeric": 450
        },
        "currency": {
            "code": "MGA",
            "nameEn": "Malagasy ariary",
            "symbol": "",
            "paypal": "",
            "stripe": ""
        },
        "official": {
            "code": "mg",
            "nameEn": "Malagasy",
            "nameLocal": "fiteny malagasy"
        },
        "tin": {
            "name": "",
            "type": ""
        },
        "flag": "🇲🇬",
        "region": "Africa"
    },
    {
        "country": {
            "code": "ML",
            "code3": "MLI",
            "phoneCode": "223",
            "nameEn": "Mali",
            "nameLocal": "Mali",
            "isoNumeric": 466
        },
        "currency": {
            "code": "XOF",
            "nameEn": "CFA franc BCEAO",
            "symbol": "",
            "paypal": "",
            "stripe": ""
        },
        "official": {
            "code": "fr",
            "nameEn": "French",
            "nameLocal": "Français"
        },
        "tin": {
            "name": "",
            "type": ""
        },
        "flag": "🇲🇱",
        "region": "Africa"
    },
    {
        "country": {
            "code": "MM",
            "code3": "MMR",
            "phoneCode": "95",
            "nameEn": "Myanmar",
            "nameLocal": "မြန်မာ",
            "isoNumeric": 104
        },
        "currency": {
            "code": "MMK",
            "nameEn": "Myanmar kyat",
            "symbol": "K",
            "paypal": "",
            "stripe": ""
        },
        "official": {
            "code": "my",
            "nameEn": "Burmese",
            "nameLocal": "ဗမာစာ"
        },
        "tin": {
            "name": "",
            "type": ""
        },
        "flag": "🇲🇲",
        "region": "Asia & Pacific"
    },
    {
        "country": {
            "code": "MN",
            "code3": "MNG",
            "phoneCode": "976",
            "nameEn": "Mongolia",
            "nameLocal": "Монгол Улс",
            "isoNumeric": 496
        },
        "currency": {
            "code": "MNT",
            "nameEn": "Mongolian tögrög",
            "symbol": "₮",
            "paypal": "0",
            "stripe": "1"
        },
        "official": {
            "code": "mn",
            "nameEn": "Mongolian",
            "nameLocal": "Монгол хэл"
        },
        "tin": {
            "name": "",
            "type": ""
        },
        "flag": "🇲🇳",
        "region": "Asia & Pacific"
    },
    {
        "country": {
            "code": "MO",
            "code3": "MAC",
            "phoneCode": "853",
            "nameEn": "Macao",
            "nameLocal": "澳門, Macau",
            "isoNumeric": 446
        },
        "currency": {
            "code": "MOP",
            "nameEn": "Macanese pataca",
            "symbol": "MOP",
            "paypal": "",
            "stripe": ""
        },
        "official": {
            "code": "zh-hant",
            "nameEn": "",
            "nameLocal": ""
        },
        "tin": {
            "name": "",
            "type": ""
        },
        "flag": "🇲🇴",
        "region": "Asia & Pacific"
    },
    {
        "country": {
            "code": "MQ",
            "code3": "MTQ",
            "phoneCode": "596",
            "nameEn": "Martinique",
            "nameLocal": "Martinique",
            "isoNumeric": 474
        },
        "currency": {
            "code": "EUR",
            "nameEn": "Euro",
            "symbol": "€",
            "paypal": "1",
            "stripe": "1"
        },
        "official": {
            "code": "fr",
            "nameEn": "French",
            "nameLocal": "Français"
        },
        "tin": {
            "name": "",
            "type": ""
        },
        "flag": "🇲🇶",
        "region": "South/Latin America"
    },
    {
        "country": {
            "code": "MR",
            "code3": "MRT",
            "phoneCode": "222",
            "nameEn": "Mauritania",
            "nameLocal": "موريتانيا, Mauritanie",
            "isoNumeric": 478
        },
        "currency": {
            "code": "MRU",
            "nameEn": "",
            "symbol": "UM",
            "paypal": "",
            "stripe": ""
        },
        "official": {
            "code": "ar",
            "nameEn": "Arabic",
            "nameLocal": "العربية"
        },
        "tin": {
            "name": "",
            "type": ""
        },
        "flag": "🇲🇷",
        "region": "Arab States"
    },
    {
        "country": {
            "code": "MS",
            "code3": "MSR",
            "phoneCode": "1664",
            "nameEn": "Montserrat",
            "nameLocal": "Montserrat",
            "isoNumeric": 500
        },
        "currency": {
            "code": "XCD",
            "nameEn": "East Caribbean dollar",
            "symbol": "$",
            "paypal": "0",
            "stripe": "1"
        },
        "official": {
            "code": "en",
            "nameEn": "English",
            "nameLocal": "English"
        },
        "tin": {
            "name": "",
            "type": ""
        },
        "flag": "🇲🇸",
        "region": "South/Latin America"
    },
    {
        "country": {
            "code": "MT",
            "code3": "MLT",
            "phoneCode": "356",
            "nameEn": "Malta",
            "nameLocal": "Malta",
            "isoNumeric": 470
        },
        "currency": {
            "code": "EUR",
            "nameEn": "Euro",
            "symbol": "",
            "paypal": "1",
            "stripe": "1"
        },
        "official": {
            "code": "mt",
            "nameEn": "Maltese",
            "nameLocal": "Malti"
        },
        "tin": {
            "name": "Vat reg. no.",
            "type": "Vat No."
        },
        "flag": "🇲🇹",
        "region": "Europe"
    },
    {
        "country": {
            "code": "MU",
            "code3": "MUS",
            "phoneCode": "230",
            "nameEn": "Mauritius",
            "nameLocal": "Maurice, Mauritius",
            "isoNumeric": 480
        },
        "currency": {
            "code": "MUR",
            "nameEn": "Mauritian rupee",
            "symbol": "₨",
            "paypal": "0",
            "stripe": "1"
        },
        "official": {
            "code": "mfe",
            "nameEn": "",
            "nameLocal": ""
        },
        "tin": {
            "name": "",
            "type": ""
        },
        "flag": "🇲🇺",
        "region": "Africa"
    },
    {
        "country": {
            "code": "MV",
            "code3": "MDV",
            "phoneCode": "960",
            "nameEn": "Maldives",
            "nameLocal": "",
            "isoNumeric": 462
        },
        "currency": {
            "code": "MVR",
            "nameEn": "Maldivian rufiyaa",
            "symbol": "Rf",
            "paypal": "",
            "stripe": ""
        },
        "official": {
            "code": "dv",
            "nameEn": "Divehi, Dhivehi, Maldivian",
            "nameLocal": "ދިވެހި"
        },
        "tin": {
            "name": "",
            "type": ""
        },
        "flag": "🇲🇻",
        "region": "Asia & Pacific"
    },
    {
        "country": {
            "code": "MW",
            "code3": "MWI",
            "phoneCode": "265",
            "nameEn": "Malawi",
            "nameLocal": "Malawi",
            "isoNumeric": 454
        },
        "currency": {
            "code": "MWK",
            "nameEn": "Malawian kwacha",
            "symbol": "MK",
            "paypal": "",
            "stripe": ""
        },
        "official": {
            "code": "en",
            "nameEn": "English",
            "nameLocal": "English"
        },
        "tin": {
            "name": "",
            "type": ""
        },
        "flag": "🇲🇼",
        "region": "Africa"
    },
    {
        "country": {
            "code": "MX",
            "code3": "MEX",
            "phoneCode": "52",
            "nameEn": "Mexico",
            "nameLocal": "México",
            "isoNumeric": 484
        },
        "currency": {
            "code": "MXN",
            "nameEn": "Mexican peso",
            "symbol": "$",
            "paypal": "1",
            "stripe": "1"
        },
        "official": {
            "code": "es",
            "nameEn": "Spanish, Castilian",
            "nameLocal": "Español"
        },
        "tin": {
            "name": "Registro Federal de Contribuyentes",
            "type": "RFC"
        },
        "flag": "🇲🇽",
        "region": "South/Latin America"
    },
    {
        "country": {
            "code": "MY",
            "code3": "MYS",
            "phoneCode": "60",
            "nameEn": "Malaysia",
            "nameLocal": "",
            "isoNumeric": 458
        },
        "currency": {
            "code": "MYR",
            "nameEn": "Malaysian ringgit",
            "symbol": "RM",
            "paypal": "1",
            "stripe": "1"
        },
        "official": {
            "code": "ms",
            "nameEn": "Malay",
            "nameLocal": "Bahasa Melayu, بهاس ملايو‎"
        },
        "tin": {
            "name": "",
            "type": ""
        },
        "flag": "🇲🇾",
        "region": "Asia & Pacific"
    },
    {
        "country": {
            "code": "MZ",
            "code3": "MOZ",
            "phoneCode": "258",
            "nameEn": "Mozambique",
            "nameLocal": "Mozambique",
            "isoNumeric": 508
        },
        "currency": {
            "code": "MZN",
            "nameEn": "Mozambican metical",
            "symbol": "MT",
            "paypal": "0",
            "stripe": "1"
        },
        "official": {
            "code": "pt",
            "nameEn": "Portuguese",
            "nameLocal": "Português"
        },
        "tin": {
            "name": "",
            "type": ""
        },
        "flag": "🇲🇿",
        "region": "Africa"
    },
    {
        "country": {
            "code": "NA",
            "code3": "NAM",
            "phoneCode": "264",
            "nameEn": "Namibia",
            "nameLocal": "Namibia",
            "isoNumeric": 516
        },
        "currency": {
            "code": "NAD",
            "nameEn": "Namibian dollar",
            "symbol": "$",
            "paypal": "0",
            "stripe": "1"
        },
        "official": {
            "code": "en",
            "nameEn": "English",
            "nameLocal": "English"
        },
        "tin": {
            "name": "",
            "type": ""
        },
        "flag": "🇳🇦",
        "region": "Africa"
    },
    {
        "country": {
            "code": "NC",
            "code3": "NCL",
            "phoneCode": "687",
            "nameEn": "New Caledonia",
            "nameLocal": "Nouvelle-Calédonie",
            "isoNumeric": 540
        },
        "currency": {
            "code": "XPF",
            "nameEn": "CFP franc (franc Pacifique)",
            "symbol": "",
            "paypal": "",
            "stripe": ""
        },
        "official": {
            "code": "fr",
            "nameEn": "French",
            "nameLocal": "Français"
        },
        "tin": {
            "name": "",
            "type": ""
        },
        "flag": "🇳🇨",
        "region": "Asia & Pacific"
    },
    {
        "country": {
            "code": "NF",
            "code3": "NFK",
            "phoneCode": "672",
            "nameEn": "Norfolk Island",
            "nameLocal": "Norfolk Island",
            "isoNumeric": 574
        },
        "currency": {
            "code": "AUD",
            "nameEn": "Australian dollar",
            "symbol": "$",
            "paypal": "1",
            "stripe": "1"
        },
        "official": {
            "code": "en",
            "nameEn": "English",
            "nameLocal": "English"
        },
        "tin": {
            "name": "",
            "type": ""
        },
        "flag": "🇳🇫",
        "region": "Asia & Pacific"
    },
    {
        "country": {
            "code": "NG",
            "code3": "NGA",
            "phoneCode": "234",
            "nameEn": "Nigeria",
            "nameLocal": "Nigeria",
            "isoNumeric": 566
        },
        "currency": {
            "code": "NGN",
            "nameEn": "Nigerian naira",
            "symbol": "₦",
            "paypal": "0",
            "stripe": "1"
        },
        "official": {
            "code": "en",
            "nameEn": "English",
            "nameLocal": "English"
        },
        "tin": {
            "name": "",
            "type": ""
        },
        "flag": "🇳🇬",
        "region": "Africa"
    },
    {
        "country": {
            "code": "NI",
            "code3": "NIC",
            "phoneCode": "505",
            "nameEn": "Nicaragua",
            "nameLocal": "Nicaragua",
            "isoNumeric": 558
        },
        "currency": {
            "code": "NIO",
            "nameEn": "Nicaraguan córdoba",
            "symbol": "C$",
            "paypal": "0",
            "stripe": "1"
        },
        "official": {
            "code": "es",
            "nameEn": "Spanish, Castilian",
            "nameLocal": "Español"
        },
        "tin": {
            "name": "Registro Unico de Contribuyentes",
            "type": "RUC"
        },
        "flag": "🇳🇮",
        "region": "South/Latin America"
    },
    {
        "country": {
            "code": "NO",
            "code3": "NOR",
            "phoneCode": "47",
            "nameEn": "Norway",
            "nameLocal": "Norge, Noreg",
            "isoNumeric": 578
        },
        "currency": {
            "code": "NOK",
            "nameEn": "Norwegian krone",
            "symbol": "kr",
            "paypal": "1",
            "stripe": "1"
        },
        "official": {
            "code": "nb",
            "nameEn": "Norwegian Bokmål",
            "nameLocal": "Norsk Bokmål"
        },
        "tin": {
            "name": "Organisasjonsnummer",
            "type": "Orgnr"
        },
        "flag": "🇳🇴",
        "region": "Europe"
    },
    {
        "country": {
            "code": "NP",
            "code3": "NPL",
            "phoneCode": "977",
            "nameEn": "Nepal",
            "nameLocal": "",
            "isoNumeric": 524
        },
        "currency": {
            "code": "NPR",
            "nameEn": "Nepalese rupee",
            "symbol": "₨",
            "paypal": "0",
            "stripe": "1"
        },
        "official": {
            "code": "ne",
            "nameEn": "Nepali",
            "nameLocal": "नेपाली"
        },
        "tin": {
            "name": "",
            "type": ""
        },
        "flag": "🇳🇵",
        "region": "Asia & Pacific"
    },
    {
        "country": {
            "code": "NR",
            "code3": "NRU",
            "phoneCode": "674",
            "nameEn": "Nauru",
            "nameLocal": "Nauru",
            "isoNumeric": 520
        },
        "currency": {
            "code": "AUD",
            "nameEn": "Australian dollar",
            "symbol": "$",
            "paypal": "1",
            "stripe": "1"
        },
        "official": {
            "code": "na",
            "nameEn": "Nauru",
            "nameLocal": "Dorerin Naoero"
        },
        "tin": {
            "name": "",
            "type": ""
        },
        "flag": "🇳🇷",
        "region": "Asia & Pacific"
    },
    {
        "country": {
            "code": "NU",
            "code3": "NIU",
            "phoneCode": "683",
            "nameEn": "Niue",
            "nameLocal": "Niue",
            "isoNumeric": 570
        },
        "currency": {
            "code": "NZD",
            "nameEn": "New Zealand dollar",
            "symbol": "$",
            "paypal": "1",
            "stripe": "1"
        },
        "official": {
            "code": "niu",
            "nameEn": "",
            "nameLocal": ""
        },
        "tin": {
            "name": "",
            "type": ""
        },
        "flag": "🇳🇺",
        "region": "Asia & Pacific"
    },
    {
        "country": {
            "code": "NZ",
            "code3": "NZL",
            "phoneCode": "64",
            "nameEn": "New Zealand",
            "nameLocal": "New Zealand",
            "isoNumeric": 554
        },
        "currency": {
            "code": "NZD",
            "nameEn": "New Zealand dollar",
            "symbol": "$",
            "paypal": "1",
            "stripe": "1"
        },
        "official": {
            "code": "mi",
            "nameEn": "Maori",
            "nameLocal": "te reo Māori"
        },
        "tin": {
            "name": "NZ Business Number",
            "type": "NZBN"
        },
        "flag": "🇳🇿",
        "region": "Asia & Pacific"
    },
    {
        "country": {
            "code": "OM",
            "code3": "OMN",
            "phoneCode": "968",
            "nameEn": "Oman",
            "nameLocal": "سلطنة عُمان",
            "isoNumeric": 512
        },
        "currency": {
            "code": "OMR",
            "nameEn": "Omani rial",
            "symbol": "﷼",
            "paypal": "0",
            "stripe": "0"
        },
        "official": {
            "code": "ar",
            "nameEn": "Arabic",
            "nameLocal": "العربية"
        },
        "tin": {
            "name": "",
            "type": ""
        },
        "flag": "🇴🇲",
        "region": "Arab States"
    },
    {
        "country": {
            "code": "PA",
            "code3": "PAN",
            "phoneCode": "507",
            "nameEn": "Panama",
            "nameLocal": "Panama",
            "isoNumeric": 591
        },
        "currency": {
            "code": "PAB",
            "nameEn": "Panamanian balboa",
            "symbol": "B/.",
            "paypal": "0",
            "stripe": "1"
        },
        "official": {
            "code": "es",
            "nameEn": "Spanish, Castilian",
            "nameLocal": "Español"
        },
        "tin": {
            "name": "Registro Unico de Contribuyentes",
            "type": "RUC"
        },
        "flag": "🇵🇦",
        "region": "South/Latin America"
    },
    {
        "country": {
            "code": "PE",
            "code3": "PER",
            "phoneCode": "51",
            "nameEn": "Peru",
            "nameLocal": "Perú",
            "isoNumeric": 604
        },
        "currency": {
            "code": "PEN",
            "nameEn": "Peruvian sol",
            "symbol": "S/.",
            "paypal": "0",
            "stripe": "1"
        },
        "official": {
            "code": "es",
            "nameEn": "Spanish, Castilian",
            "nameLocal": "Español"
        },
        "tin": {
            "name": "Registro Unico de Contribuyentes",
            "type": "RUC"
        },
        "flag": "🇵🇪",
        "region": "South/Latin America"
    },
    {
        "country": {
            "code": "PF",
            "code3": "PYF",
            "phoneCode": "689",
            "nameEn": "French Polynesia",
            "nameLocal": "Polynésie française",
            "isoNumeric": 258
        },
        "currency": {
            "code": "XPF",
            "nameEn": "CFP franc (franc Pacifique)",
            "symbol": "",
            "paypal": "",
            "stripe": ""
        },
        "official": {
            "code": "fr",
            "nameEn": "French",
            "nameLocal": "Français"
        },
        "tin": {
            "name": "",
            "type": ""
        },
        "flag": "🇵🇫",
        "region": "Asia & Pacific"
    },
    {
        "country": {
            "code": "PG",
            "code3": "PNG",
            "phoneCode": "675",
            "nameEn": "Papua New Guinea",
            "nameLocal": "Papua New Guinea",
            "isoNumeric": 598
        },
        "currency": {
            "code": "PGK",
            "nameEn": "Papua New Guinean kina",
            "symbol": "",
            "paypal": "",
            "stripe": ""
        },
        "official": {
            "code": "en",
            "nameEn": "English",
            "nameLocal": "English"
        },
        "tin": {
            "name": "",
            "type": ""
        },
        "flag": "🇵🇬",
        "region": "Asia & Pacific"
    },
    {
        "country": {
            "code": "PK",
            "code3": "PAK",
            "phoneCode": "92",
            "nameEn": "Pakistan",
            "nameLocal": "پاکستان",
            "isoNumeric": 586
        },
        "currency": {
            "code": "PKR",
            "nameEn": "Pakistani rupee",
            "symbol": "₨",
            "paypal": "0",
            "stripe": "1"
        },
        "official": {
            "code": "en",
            "nameEn": "English",
            "nameLocal": "English"
        },
        "tin": {
            "name": "",
            "type": ""
        },
        "flag": "🇵🇰",
        "region": "Asia & Pacific"
    },
    {
        "country": {
            "code": "PL",
            "code3": "POL",
            "phoneCode": "48",
            "nameEn": "Poland",
            "nameLocal": "Polska",
            "isoNumeric": 616
        },
        "currency": {
            "code": "PLN",
            "nameEn": "Polish złoty",
            "symbol": "zł",
            "paypal": "1",
            "stripe": "1"
        },
        "official": {
            "code": "pl",
            "nameEn": "Polish",
            "nameLocal": "język polski, polszczyzna"
        },
        "tin": {
            "name": "numer identyfikacji podatkowej",
            "type": "NIP"
        },
        "flag": "🇵🇱",
        "region": "Europe"
    },
    {
        "country": {
            "code": "PM",
            "code3": "SPM",
            "phoneCode": "508",
            "nameEn": "Saint Pierre and Miquelon",
            "nameLocal": "Saint-Pierre-et-Miquelon",
            "isoNumeric": 666
        },
        "currency": {
            "code": "EUR",
            "nameEn": "Euro",
            "symbol": "€",
            "paypal": "1",
            "stripe": "1"
        },
        "official": {
            "code": "fr",
            "nameEn": "French",
            "nameLocal": "Français"
        },
        "tin": {
            "name": "",
            "type": ""
        },
        "flag": "🇵🇲",
        "region": "North America"
    },
    {
        "country": {
            "code": "PN",
            "code3": "PCN",
            "phoneCode": "64",
            "nameEn": "Pitcairn",
            "nameLocal": "Pitcairn",
            "isoNumeric": 612
        },
        "currency": {
            "code": "NZD",
            "nameEn": "New Zealand dollar",
            "symbol": "$",
            "paypal": "1",
            "stripe": "1"
        },
        "official": {
            "code": "en",
            "nameEn": "English",
            "nameLocal": "English"
        },
        "tin": {
            "name": "",
            "type": ""
        },
        "flag": "🇵🇳",
        "region": "Asia & Pacific"
    },
    {
        "country": {
            "code": "PR",
            "code3": "PRI",
            "phoneCode": "1",
            "nameEn": "Puerto Rico",
            "nameLocal": "Puerto Rico",
            "isoNumeric": 630
        },
        "currency": {
            "code": "USD",
            "nameEn": "United States dollar",
            "symbol": "$",
            "paypal": "1",
            "stripe": "1"
        },
        "official": {
            "code": "es",
            "nameEn": "Spanish, Castilian",
            "nameLocal": "Español"
        },
        "tin": {
            "name": "",
            "type": ""
        },
        "flag": "🇵🇷",
        "region": "South/Latin America"
    },
    {
        "country": {
            "code": "PS",
            "code3": "PSE",
            "phoneCode": "970",
            "nameEn": "Palestine, State of",
            "nameLocal": "Palestinian Territory",
            "isoNumeric": 275
        },
        "currency": {
            "code": "",
            "nameEn": "",
            "symbol": "₪",
            "paypal": "",
            "stripe": ""
        },
        "official": {
            "code": "ar",
            "nameEn": "Arabic",
            "nameLocal": "العربية"
        },
        "tin": {
            "name": "",
            "type": ""
        },
        "flag": "🇵🇸",
        "region": "Arab States"
    },
    {
        "country": {
            "code": "PT",
            "code3": "PRT",
            "phoneCode": "351",
            "nameEn": "Portugal",
            "nameLocal": "Portugal",
            "isoNumeric": 620
        },
        "currency": {
            "code": "EUR",
            "nameEn": "Euro",
            "symbol": "€",
            "paypal": "1",
            "stripe": "1"
        },
        "official": {
            "code": "pt",
            "nameEn": "Portuguese",
            "nameLocal": "Português"
        },
        "tin": {
            "name": "Número de Identificação de Pessoa Coletiva (NIPC)",
            "type": "NIPC"
        },
        "flag": "🇵🇹",
        "region": "Europe"
    },
    {
        "country": {
            "code": "PW",
            "code3": "PLW",
            "phoneCode": "680",
            "nameEn": "Palau",
            "nameLocal": "Palau",
            "isoNumeric": 585
        },
        "currency": {
            "code": "USD",
            "nameEn": "United States dollar",
            "symbol": "$",
            "paypal": "1",
            "stripe": "1"
        },
        "official": {
            "code": "en",
            "nameEn": "English",
            "nameLocal": "English"
        },
        "tin": {
            "name": "",
            "type": ""
        },
        "flag": "🇵🇼",
        "region": "Asia & Pacific"
    },
    {
        "country": {
            "code": "PY",
            "code3": "PRY",
            "phoneCode": "595",
            "nameEn": "Paraguay",
            "nameLocal": "Paraguay",
            "isoNumeric": 600
        },
        "currency": {
            "code": "PYG",
            "nameEn": "Paraguayan guaraní",
            "symbol": "Gs",
            "paypal": "0",
            "stripe": "1"
        },
        "official": {
            "code": "es",
            "nameEn": "Spanish, Castilian",
            "nameLocal": "Español"
        },
        "tin": {
            "name": "Registro Unico de Contribuyentes",
            "type": "RUC"
        },
        "flag": "🇵🇾",
        "region": "South/Latin America"
    },
    {
        "country": {
            "code": "QA",
            "code3": "QAT",
            "phoneCode": "974",
            "nameEn": "Qatar",
            "nameLocal": "قطر",
            "isoNumeric": 634
        },
        "currency": {
            "code": "QAR",
            "nameEn": "Qatari riyal",
            "symbol": "﷼",
            "paypal": "0",
            "stripe": "1"
        },
        "official": {
            "code": "ar",
            "nameEn": "Arabic",
            "nameLocal": "العربية"
        },
        "tin": {
            "name": "",
            "type": ""
        },
        "flag": "🇶🇦",
        "region": "Arab States"
    },
    {
        "country": {
            "code": "RE",
            "code3": "REU",
            "phoneCode": "262",
            "nameEn": "Réunion",
            "nameLocal": "La Réunion",
            "isoNumeric": 638
        },
        "currency": {
            "code": "EUR",
            "nameEn": "Euro",
            "symbol": "€",
            "paypal": "1",
            "stripe": "1"
        },
        "official": {
            "code": "fr",
            "nameEn": "French",
            "nameLocal": "Français"
        },
        "tin": {
            "name": "",
            "type": ""
        },
        "flag": "🇷🇪",
        "region": "Asia & Pacific"
    },
    {
        "country": {
            "code": "RO",
            "code3": "ROU",
            "phoneCode": "40",
            "nameEn": "Romania",
            "nameLocal": "România",
            "isoNumeric": 642
        },
        "currency": {
            "code": "RON",
            "nameEn": "Romanian leu",
            "symbol": "lei",
            "paypal": "0",
            "stripe": "1"
        },
        "official": {
            "code": "ro",
            "nameEn": "Romanian, Moldavian, Moldovan",
            "nameLocal": "Română"
        },
        "tin": {
            "name": "Codul de identificare fiscală",
            "type": "CIF"
        },
        "flag": "🇷🇴",
        "region": "Europe"
    },
    {
        "country": {
            "code": "RS",
            "code3": "",
            "phoneCode": "381",
            "nameEn": "Serbia",
            "nameLocal": "Србија",
            "isoNumeric": ""
        },
        "currency": {
            "code": "RSD",
            "nameEn": "Serbian dinar",
            "symbol": "",
            "paypal": "0",
            "stripe": "1"
        },
        "official": {
            "code": "sr",
            "nameEn": "Serbian",
            "nameLocal": "српски језик"
        },
        "tin": {
            "name": "Poreski identifikacioni broj",
            "type": "PIB"
        },
        "flag": "🇷🇸",
        "region": "Europe"
    },
    {
        "country": {
            "code": "RU",
            "code3": "RUS",
            "phoneCode": "7",
            "nameEn": "Russia",
            "nameLocal": "Россия",
            "isoNumeric": 643
        },
        "currency": {
            "code": "RUB",
            "nameEn": "Russian ruble",
            "symbol": "руб",
            "paypal": "1",
            "stripe": "1"
        },
        "official": {
            "code": "ru",
            "nameEn": "Russian",
            "nameLocal": "русский"
        },
        "tin": {
            "name": "Идентификационный номер налогоплательщика",
            "type": "ИНН"
        },
        "flag": "🇷🇺",
        "region": "Europe"
    },
    {
        "country": {
            "code": "RW",
            "code3": "RWA",
            "phoneCode": "250",
            "nameEn": "Rwanda",
            "nameLocal": "Rwanda",
            "isoNumeric": 646
        },
        "currency": {
            "code": "RWF",
            "nameEn": "Rwandan franc",
            "symbol": "",
            "paypal": "",
            "stripe": ""
        },
        "official": {
            "code": "rw",
            "nameEn": "Kinyarwanda",
            "nameLocal": "Ikinyarwanda"
        },
        "tin": {
            "name": "",
            "type": ""
        },
        "flag": "🇷🇼",
        "region": "Africa"
    },
    {
        "country": {
            "code": "SA",
            "code3": "SAU",
            "phoneCode": "966",
            "nameEn": "Saudi Arabia",
            "nameLocal": "السعودية",
            "isoNumeric": 682
        },
        "currency": {
            "code": "SAR",
            "nameEn": "Saudi riyal",
            "symbol": "﷼",
            "paypal": "0",
            "stripe": "1"
        },
        "official": {
            "code": "ar",
            "nameEn": "Arabic",
            "nameLocal": "العربية"
        },
        "tin": {
            "name": "",
            "type": ""
        },
        "flag": "🇸🇦",
        "region": "Arab States"
    },
    {
        "country": {
            "code": "SB",
            "code3": "SLB",
            "phoneCode": "677",
            "nameEn": "Solomon Islands",
            "nameLocal": "Solomon Islands",
            "isoNumeric": 90
        },
        "currency": {
            "code": "SBD",
            "nameEn": "Solomon Islands dollar",
            "symbol": "$",
            "paypal": "0",
            "stripe": "1"
        },
        "official": {
            "code": "en",
            "nameEn": "English",
            "nameLocal": "English"
        },
        "tin": {
            "name": "",
            "type": ""
        },
        "flag": "🇸🇧",
        "region": "Asia & Pacific"
    },
    {
        "country": {
            "code": "SC",
            "code3": "SYC",
            "phoneCode": "248",
            "nameEn": "Seychelles",
            "nameLocal": "Seychelles",
            "isoNumeric": 690
        },
        "currency": {
            "code": "SCR",
            "nameEn": "Seychelles rupee",
            "symbol": "₨",
            "paypal": "0",
            "stripe": "1"
        },
        "official": {
            "code": "fr",
            "nameEn": "French",
            "nameLocal": "Français"
        },
        "tin": {
            "name": "",
            "type": ""
        },
        "flag": "🇸🇨",
        "region": "Africa"
    },
    {
        "country": {
            "code": "SE",
            "code3": "SWE",
            "phoneCode": "46",
            "nameEn": "Sweden",
            "nameLocal": "Sverige",
            "isoNumeric": 752
        },
        "currency": {
            "code": "SEK",
            "nameEn": "Swedish krona/kronor",
            "symbol": "kr",
            "paypal": "1",
            "stripe": "1"
        },
        "official": {
            "code": "sv",
            "nameEn": "Swedish",
            "nameLocal": "Svenska"
        },
        "tin": {
            "name": "VAT-nummer",
            "type": "Momsnr."
        },
        "flag": "🇸🇪",
        "region": "Europe"
    },
    {
        "country": {
            "code": "SG",
            "code3": "SGP",
            "phoneCode": "65",
            "nameEn": "Singapore",
            "nameLocal": "Singapore",
            "isoNumeric": 702
        },
        "currency": {
            "code": "SGD",
            "nameEn": "Singapore dollar",
            "symbol": "$",
            "paypal": "1",
            "stripe": "1"
        },
        "official": {
            "code": "zh-hans",
            "nameEn": "",
            "nameLocal": ""
        },
        "tin": {
            "name": "",
            "type": ""
        },
        "flag": "🇸🇬",
        "region": "Asia & Pacific"
    },
    {
        "country": {
            "code": "SH",
            "code3": "SHN",
            "phoneCode": "290",
            "nameEn": "Saint Helena, Ascension and Tristan da Cunha",
            "nameLocal": "Saint Helena",
            "isoNumeric": 654
        },
        "currency": {
            "code": "SHP",
            "nameEn": "Saint Helena pound",
            "symbol": "£",
            "paypal": "0",
            "stripe": "1"
        },
        "official": {
            "code": "en",
            "nameEn": "English",
            "nameLocal": "English"
        },
        "tin": {
            "name": "",
            "type": ""
        },
        "flag": "🇸🇭",
        "region": "Africa"
    },
    {
        "country": {
            "code": "SI",
            "code3": "SVN",
            "phoneCode": "386",
            "nameEn": "Slovenia",
            "nameLocal": "Slovenija",
            "isoNumeric": 705
        },
        "currency": {
            "code": "EUR",
            "nameEn": "Euro",
            "symbol": "€",
            "paypal": "1",
            "stripe": "1"
        },
        "official": {
            "code": "sl",
            "nameEn": "Slovenian",
            "nameLocal": "Slovenski Jezik, Slovenščina"
        },
        "tin": {
            "name": "Davčna številka",
            "type": "ID za DDV"
        },
        "flag": "🇸🇮",
        "region": "Europe"
    },
    {
        "country": {
            "code": "SJ",
            "code3": "SJM",
            "phoneCode": "4779",
            "nameEn": "Svalbard and Jan Mayen",
            "nameLocal": "Svalbard and Jan Mayen",
            "isoNumeric": 744
        },
        "currency": {
            "code": "NOK",
            "nameEn": "Norwegian krone",
            "symbol": "kr",
            "paypal": "1",
            "stripe": "1"
        },
        "official": {
            "code": "no",
            "nameEn": "Norwegian",
            "nameLocal": "Norsk"
        },
        "tin": {
            "name": "",
            "type": ""
        },
        "flag": "🇸🇯",
        "region": "Europe"
    },
    {
        "country": {
            "code": "SK",
            "code3": "SVK",
            "phoneCode": "421",
            "nameEn": "Slovakia",
            "nameLocal": "Slovensko",
            "isoNumeric": 703
        },
        "currency": {
            "code": "EUR",
            "nameEn": "Euro",
            "symbol": "Sk",
            "paypal": "1",
            "stripe": "1"
        },
        "official": {
            "code": "sk",
            "nameEn": "Slovak",
            "nameLocal": "Slovenčina, Slovenský Jazyk"
        },
        "tin": {
            "name": "Identifikačné číslo pre daň z pridanej hodnoty",
            "type": "IČ DPH"
        },
        "flag": "🇸🇰",
        "region": "Europe"
    },
    {
        "country": {
            "code": "SL",
            "code3": "SLE",
            "phoneCode": "232",
            "nameEn": "Sierra Leone",
            "nameLocal": "Sierra Leone",
            "isoNumeric": 694
        },
        "currency": {
            "code": "SLL",
            "nameEn": "Sierra Leonean leone",
            "symbol": "Le",
            "paypal": "",
            "stripe": ""
        },
        "official": {
            "code": "en",
            "nameEn": "English",
            "nameLocal": "English"
        },
        "tin": {
            "name": "",
            "type": ""
        },
        "flag": "🇸🇱",
        "region": "Africa"
    },
    {
        "country": {
            "code": "SM",
            "code3": "SMR",
            "phoneCode": "378",
            "nameEn": "San Marino",
            "nameLocal": "San Marino",
            "isoNumeric": 674
        },
        "currency": {
            "code": "EUR",
            "nameEn": "Euro",
            "symbol": "€",
            "paypal": "1",
            "stripe": "1"
        },
        "official": {
            "code": "it",
            "nameEn": "Italian",
            "nameLocal": "Italiano"
        },
        "tin": {
            "name": "Codice operatore economico",
            "type": "C.O.E."
        },
        "flag": "🇸🇲",
        "region": "Europe"
    },
    {
        "country": {
            "code": "SN",
            "code3": "SEN",
            "phoneCode": "221",
            "nameEn": "Senegal",
            "nameLocal": "Sénégal",
            "isoNumeric": 686
        },
        "currency": {
            "code": "XOF",
            "nameEn": "CFA franc BCEAO",
            "symbol": "",
            "paypal": "",
            "stripe": ""
        },
        "official": {
            "code": "fr",
            "nameEn": "French",
            "nameLocal": "Français"
        },
        "tin": {
            "name": "",
            "type": ""
        },
        "flag": "🇸🇳",
        "region": "Africa"
    },
    {
        "country": {
            "code": "SO",
            "code3": "SOM",
            "phoneCode": "252",
            "nameEn": "Somalia",
            "nameLocal": "Somalia, الصومال",
            "isoNumeric": 706
        },
        "currency": {
            "code": "SOS",
            "nameEn": "Somali shilling",
            "symbol": "S",
            "paypal": "0",
            "stripe": "1"
        },
        "official": {
            "code": "so",
            "nameEn": "Somali",
            "nameLocal": "Soomaaliga, af Soomaali"
        },
        "tin": {
            "name": "",
            "type": ""
        },
        "flag": "🇸🇴",
        "region": "Arab States"
    },
    {
        "country": {
            "code": "SR",
            "code3": "SUR",
            "phoneCode": "597",
            "nameEn": "Suriname",
            "nameLocal": "Suriname",
            "isoNumeric": 740
        },
        "currency": {
            "code": "SRD",
            "nameEn": "Surinamese dollar",
            "symbol": "$",
            "paypal": "0",
            "stripe": "1"
        },
        "official": {
            "code": "nl",
            "nameEn": "Dutch, Flemish",
            "nameLocal": "Nederlands, Vlaams"
        },
        "tin": {
            "name": "",
            "type": ""
        },
        "flag": "🇸🇷",
        "region": "South/Latin America"
    },
    {
        "country": {
            "code": "SS",
            "code3": "",
            "phoneCode": "211",
            "nameEn": "South Sudan",
            "nameLocal": "South Sudan",
            "isoNumeric": ""
        },
        "currency": {
            "code": "SSP",
            "nameEn": "South Sudanese pound",
            "symbol": "",
            "paypal": "",
            "stripe": ""
        },
        "official": {
            "code": "en",
            "nameEn": "English",
            "nameLocal": "English"
        },
        "tin": {
            "name": "",
            "type": ""
        },
        "flag": "🇸🇸",
        "region": "Africa"
    },
    {
        "country": {
            "code": "ST",
            "code3": "STP",
            "phoneCode": "239",
            "nameEn": "Sao Tome and Principe",
            "nameLocal": "São Tomé e Príncipe",
            "isoNumeric": 678
        },
        "currency": {
            "code": "STN",
            "nameEn": "",
            "symbol": "Db",
            "paypal": "",
            "stripe": ""
        },
        "official": {
            "code": "pt",
            "nameEn": "Portuguese",
            "nameLocal": "Português"
        },
        "tin": {
            "name": "",
            "type": ""
        },
        "flag": "🇸🇹",
        "region": "Africa"
    },
    {
        "country": {
            "code": "SV",
            "code3": "SLV",
            "phoneCode": "503",
            "nameEn": "El Salvador",
            "nameLocal": "El Salvador",
            "isoNumeric": 222
        },
        "currency": {
            "code": "SVC",
            "nameEn": "Salvadoran colón",
            "symbol": "$",
            "paypal": "0",
            "stripe": "0"
        },
        "official": {
            "code": "es",
            "nameEn": "Spanish, Castilian",
            "nameLocal": "Español"
        },
        "tin": {
            "name": "Número de Identificación Tributaria",
            "type": "NIT"
        },
        "flag": "🇸🇻",
        "region": "South/Latin America"
    },
    {
        "country": {
            "code": "SX",
            "code3": "",
            "phoneCode": "1721",
            "nameEn": "Sint Maarten (Dutch part)",
            "nameLocal": "Sint Maarten",
            "isoNumeric": ""
        },
        "currency": {
            "code": "ANG",
            "nameEn": "Netherlands Antillean guilder",
            "symbol": "",
            "paypal": "0",
            "stripe": "1"
        },
        "official": {
            "code": "nl",
            "nameEn": "Dutch, Flemish",
            "nameLocal": "Nederlands, Vlaams"
        },
        "tin": {
            "name": "",
            "type": ""
        },
        "flag": "🇸🇽",
        "region": "Unknown"
    },
    {
        "country": {
            "code": "SY",
            "code3": "SYR",
            "phoneCode": "963",
            "nameEn": "Syrian Arab Republic",
            "nameLocal": "سوريا, Sūriyya",
            "isoNumeric": 760
        },
        "currency": {
            "code": "SYP",
            "nameEn": "Syrian pound",
            "symbol": "£",
            "paypal": "0",
            "stripe": "0"
        },
        "official": {
            "code": "ar",
            "nameEn": "Arabic",
            "nameLocal": "العربية"
        },
        "tin": {
            "name": "",
            "type": ""
        },
        "flag": "🇸🇾",
        "region": "Asia & Pacific"
    },
    {
        "country": {
            "code": "TD",
            "code3": "TCD",
            "phoneCode": "235",
            "nameEn": "Chad",
            "nameLocal": "Tchad, تشاد",
            "isoNumeric": 148
        },
        "currency": {
            "code": "XAF",
            "nameEn": "CFA franc BEAC",
            "symbol": "",
            "paypal": "",
            "stripe": ""
        },
        "official": {
            "code": "fr",
            "nameEn": "French",
            "nameLocal": "Français"
        },
        "tin": {
            "name": "",
            "type": ""
        },
        "flag": "🇹🇩",
        "region": "Africa"
    },
    {
        "country": {
            "code": "TG",
            "code3": "TGO",
            "phoneCode": "228",
            "nameEn": "Togo",
            "nameLocal": "Togo",
            "isoNumeric": 768
        },
        "currency": {
            "code": "XOF",
            "nameEn": "CFA franc BCEAO",
            "symbol": "",
            "paypal": "",
            "stripe": ""
        },
        "official": {
            "code": "fr",
            "nameEn": "French",
            "nameLocal": "Français"
        },
        "tin": {
            "name": "",
            "type": ""
        },
        "flag": "🇹🇬",
        "region": "Africa"
    },
    {
        "country": {
            "code": "TH",
            "code3": "THA",
            "phoneCode": "66",
            "nameEn": "Thailand",
            "nameLocal": "ประเทศไทย",
            "isoNumeric": 764
        },
        "currency": {
            "code": "THB",
            "nameEn": "Thai baht",
            "symbol": "฿",
            "paypal": "1",
            "stripe": "1"
        },
        "official": {
            "code": "th",
            "nameEn": "Thai",
            "nameLocal": "ไทย"
        },
        "tin": {
            "name": "",
            "type": ""
        },
        "flag": "🇹🇭",
        "region": "Asia & Pacific"
    },
    {
        "country": {
            "code": "TJ",
            "code3": "TJK",
            "phoneCode": "992",
            "nameEn": "Tajikistan",
            "nameLocal": ",",
            "isoNumeric": 762
        },
        "currency": {
            "code": "TJS",
            "nameEn": "Tajikistani somoni",
            "symbol": "",
            "paypal": "",
            "stripe": ""
        },
        "official": {
            "code": "tg",
            "nameEn": "Tajik",
            "nameLocal": "тоҷикӣ, toçikī, تاجیکی‎"
        },
        "tin": {
            "name": "",
            "type": ""
        },
        "flag": "🇹🇯",
        "region": "Asia & Pacific"
    },
    {
        "country": {
            "code": "TK",
            "code3": "TKL",
            "phoneCode": "690",
            "nameEn": "Tokelau",
            "nameLocal": "Tokelau",
            "isoNumeric": 772
        },
        "currency": {
            "code": "NZD",
            "nameEn": "New Zealand dollar",
            "symbol": "$",
            "paypal": "1",
            "stripe": "1"
        },
        "official": {
            "code": "tkl",
            "nameEn": "",
            "nameLocal": ""
        },
        "tin": {
            "name": "",
            "type": ""
        },
        "flag": "🇹🇰",
        "region": "Asia & Pacific"
    },
    {
        "country": {
            "code": "TL",
            "code3": "TLS",
            "phoneCode": "670",
            "nameEn": "Timor-Leste",
            "nameLocal": "Timor-Leste, Timor Lorosa'e",
            "isoNumeric": 626
        },
        "currency": {
            "code": "USD",
            "nameEn": "United States dollar",
            "symbol": "$",
            "paypal": "1",
            "stripe": "1"
        },
        "official": {
            "code": "pt",
            "nameEn": "Portuguese",
            "nameLocal": "Português"
        },
        "tin": {
            "name": "",
            "type": ""
        },
        "flag": "🇹🇱",
        "region": "Asia & Pacific"
    },
    {
        "country": {
            "code": "TM",
            "code3": "TKM",
            "phoneCode": "993",
            "nameEn": "Turkmenistan",
            "nameLocal": "Türkmenistan",
            "isoNumeric": 795
        },
        "currency": {
            "code": "TMT",
            "nameEn": "Turkmenistan manat",
            "symbol": "m",
            "paypal": "",
            "stripe": ""
        },
        "official": {
            "code": "tk",
            "nameEn": "Turkmen",
            "nameLocal": "Türkmen, Түркмен"
        },
        "tin": {
            "name": "",
            "type": ""
        },
        "flag": "🇹🇲",
        "region": "Asia & Pacific"
    },
    {
        "country": {
            "code": "TN",
            "code3": "TUN",
            "phoneCode": "216",
            "nameEn": "Tunisia",
            "nameLocal": "تونس, Tunisie",
            "isoNumeric": 788
        },
        "currency": {
            "code": "TND",
            "nameEn": "Tunisian dinar",
            "symbol": "",
            "paypal": "",
            "stripe": ""
        },
        "official": {
            "code": "ar",
            "nameEn": "Arabic",
            "nameLocal": "العربية"
        },
        "tin": {
            "name": "",
            "type": ""
        },
        "flag": "🇹🇳",
        "region": "Arab States"
    },
    {
        "country": {
            "code": "TO",
            "code3": "TON",
            "phoneCode": "676",
            "nameEn": "Tonga",
            "nameLocal": "Tonga",
            "isoNumeric": 776
        },
        "currency": {
            "code": "TOP",
            "nameEn": "Tongan paʻanga",
            "symbol": "T$",
            "paypal": "",
            "stripe": ""
        },
        "official": {
            "code": "en",
            "nameEn": "English",
            "nameLocal": "English"
        },
        "tin": {
            "name": "",
            "type": ""
        },
        "flag": "🇹🇴",
        "region": "Asia & Pacific"
    },
    {
        "country": {
            "code": "TR",
            "code3": "TUR",
            "phoneCode": "90",
            "nameEn": "Turkey",
            "nameLocal": "Türkiye",
            "isoNumeric": 792
        },
        "currency": {
            "code": "TRY",
            "nameEn": "Turkish lira",
            "symbol": "YTL",
            "paypal": "0",
            "stripe": "1"
        },
        "official": {
            "code": "tr",
            "nameEn": "Turkish",
            "nameLocal": "Türkçe"
        },
        "tin": {
            "name": "Vergi Kimlik Numarası",
            "type": "KDV"
        },
        "flag": "🇹🇷",
        "region": "Europe"
    },
    {
        "country": {
            "code": "TT",
            "code3": "TTO",
            "phoneCode": "868",
            "nameEn": "Trinidad and Tobago",
            "nameLocal": "Trinidad and Tobago",
            "isoNumeric": 780
        },
        "currency": {
            "code": "TTD",
            "nameEn": "Trinidad and Tobago dollar",
            "symbol": "TT$",
            "paypal": "0",
            "stripe": "1"
        },
        "official": {
            "code": "en",
            "nameEn": "English",
            "nameLocal": "English"
        },
        "tin": {
            "name": "",
            "type": ""
        },
        "flag": "🇹🇹",
        "region": "South/Latin America"
    },
    {
        "country": {
            "code": "TV",
            "code3": "TUV",
            "phoneCode": "688",
            "nameEn": "Tuvalu",
            "nameLocal": "Tuvalu",
            "isoNumeric": 798
        },
        "currency": {
            "code": "AUD",
            "nameEn": "Australian dollar",
            "symbol": "$",
            "paypal": "1",
            "stripe": "1"
        },
        "official": {
            "code": "en",
            "nameEn": "English",
            "nameLocal": "English"
        },
        "tin": {
            "name": "",
            "type": ""
        },
        "flag": "🇹🇻",
        "region": "Asia & Pacific"
    },
    {
        "country": {
            "code": "TZ",
            "code3": "TZA",
            "phoneCode": "255",
            "nameEn": "United Republic of Tanzania",
            "nameLocal": "Tanzania",
            "isoNumeric": 834
        },
        "currency": {
            "code": "TZS",
            "nameEn": "Tanzanian shilling",
            "symbol": "",
            "paypal": "",
            "stripe": ""
        },
        "official": {
            "code": "sw",
            "nameEn": "Swahili",
            "nameLocal": "Kiswahili"
        },
        "tin": {
            "name": "",
            "type": ""
        },
        "flag": "🇹🇿",
        "region": "Africa"
    },
    {
        "country": {
            "code": "UA",
            "code3": "UKR",
            "phoneCode": "380",
            "nameEn": "Ukraine",
            "nameLocal": "Україна",
            "isoNumeric": 804
        },
        "currency": {
            "code": "UAH",
            "nameEn": "Ukrainian hryvnia",
            "symbol": "₴",
            "paypal": "0",
            "stripe": "1"
        },
        "official": {
            "code": "uk",
            "nameEn": "Ukrainian",
            "nameLocal": "Українська"
        },
        "tin": {
            "name": "Ідентифікаційний номер платника податків",
            "type": "ІНПП"
        },
        "flag": "🇺🇦",
        "region": "Europe"
    },
    {
        "country": {
            "code": "UG",
            "code3": "UGA",
            "phoneCode": "256",
            "nameEn": "Uganda",
            "nameLocal": "Uganda",
            "isoNumeric": 800
        },
        "currency": {
            "code": "UGX",
            "nameEn": "Ugandan shilling",
            "symbol": "",
            "paypal": "",
            "stripe": ""
        },
        "official": {
            "code": "en",
            "nameEn": "English",
            "nameLocal": "English"
        },
        "tin": {
            "name": "",
            "type": ""
        },
        "flag": "🇺🇬",
        "region": "Africa"
    },
    {
        "country": {
            "code": "US",
            "code3": "USA",
            "phoneCode": "1",
            "nameEn": "United States of America",
            "nameLocal": "United States of America",
            "isoNumeric": 840
        },
        "currency": {
            "code": "USD",
            "nameEn": "United States dollar",
            "symbol": "$",
            "paypal": "1",
            "stripe": "1"
        },
        "official": {
            "code": "en",
            "nameEn": "English",
            "nameLocal": "English"
        },
        "tin": {
            "name": "Tax Identification Number",
            "type": "EIN"
        },
        "flag": "🇺🇸",
        "region": "North America"
    },
    {
        "country": {
            "code": "UY",
            "code3": "URY",
            "phoneCode": "598",
            "nameEn": "Uruguay",
            "nameLocal": "Uruguay",
            "isoNumeric": 858
        },
        "currency": {
            "code": "UYU",
            "nameEn": "Uruguayan peso",
            "symbol": "$U",
            "paypal": "0",
            "stripe": "1"
        },
        "official": {
            "code": "es",
            "nameEn": "Spanish, Castilian",
            "nameLocal": "Español"
        },
        "tin": {
            "name": "Registro Único Tributario",
            "type": "RUT"
        },
        "flag": "🇺🇾",
        "region": "South/Latin America"
    },
    {
        "country": {
            "code": "UZ",
            "code3": "UZB",
            "phoneCode": "998",
            "nameEn": "Uzbekistan",
            "nameLocal": "",
            "isoNumeric": 860
        },
        "currency": {
            "code": "UZS",
            "nameEn": "Uzbekistan som",
            "symbol": "лв",
            "paypal": "0",
            "stripe": "1"
        },
        "official": {
            "code": "uz",
            "nameEn": "Uzbek",
            "nameLocal": "Oʻzbek, Ўзбек, أۇزبېك‎"
        },
        "tin": {
            "name": "Солиқ тўловчиларнинг идентификация рақами",
            "type": "СТИР"
        },
        "flag": "🇺🇿",
        "region": "Asia & Pacific"
    },
    {
        "country": {
            "code": "VC",
            "code3": "VCT",
            "phoneCode": "1784",
            "nameEn": "Saint Vincent and the Grenadines",
            "nameLocal": "Saint Vincent and the Grenadines",
            "isoNumeric": 670
        },
        "currency": {
            "code": "XCD",
            "nameEn": "East Caribbean dollar",
            "symbol": "$",
            "paypal": "0",
            "stripe": "1"
        },
        "official": {
            "code": "en",
            "nameEn": "English",
            "nameLocal": "English"
        },
        "tin": {
            "name": "",
            "type": ""
        },
        "flag": "🇻🇨",
        "region": "South/Latin America"
    },
    {
        "country": {
            "code": "VE",
            "code3": "VEN",
            "phoneCode": "58",
            "nameEn": "Venezuela (Bolivarian Republic of)",
            "nameLocal": "Venezuela",
            "isoNumeric": 862
        },
        "currency": {
            "code": "VES",
            "nameEn": "",
            "symbol": "Bs",
            "paypal": "",
            "stripe": ""
        },
        "official": {
            "code": "es",
            "nameEn": "Spanish, Castilian",
            "nameLocal": "Español"
        },
        "tin": {
            "name": "Registro de Informacion Fiscal",
            "type": "RIF"
        },
        "flag": "🇻🇪",
        "region": "South/Latin America"
    },
    {
        "country": {
            "code": "VG",
            "code3": "VGB",
            "phoneCode": "1284",
            "nameEn": "Virgin Islands (British)",
            "nameLocal": "British Virgin Islands",
            "isoNumeric": 92
        },
        "currency": {
            "code": "USD",
            "nameEn": "United States dollar",
            "symbol": "$",
            "paypal": "1",
            "stripe": "1"
        },
        "official": {
            "code": "en",
            "nameEn": "English",
            "nameLocal": "English"
        },
        "tin": {
            "name": "",
            "type": ""
        },
        "flag": "🇻🇬",
        "region": "South/Latin America"
    },
    {
        "country": {
            "code": "VI",
            "code3": "VIR",
            "phoneCode": "1340",
            "nameEn": "Virgin Islands (U.S.)",
            "nameLocal": "United States Virgin Islands",
            "isoNumeric": 850
        },
        "currency": {
            "code": "USD",
            "nameEn": "United States dollar",
            "symbol": "$",
            "paypal": "1",
            "stripe": "1"
        },
        "official": {
            "code": "en",
            "nameEn": "English",
            "nameLocal": "English"
        },
        "tin": {
            "name": "",
            "type": ""
        },
        "flag": "🇻🇮",
        "region": "South/Latin America"
    },
    {
        "country": {
            "code": "VN",
            "code3": "VNM",
            "phoneCode": "84",
            "nameEn": "Vietnam",
            "nameLocal": "Việt Nam",
            "isoNumeric": 704
        },
        "currency": {
            "code": "VND",
            "nameEn": "Vietnamese đồng",
            "symbol": "₫",
            "paypal": "0",
            "stripe": "1"
        },
        "official": {
            "code": "vi",
            "nameEn": "Vietnamese",
            "nameLocal": "Tiếng Việt"
        },
        "tin": {
            "name": "",
            "type": ""
        },
        "flag": "🇻🇳",
        "region": "Asia & Pacific"
    },
    {
        "country": {
            "code": "VU",
            "code3": "VUT",
            "phoneCode": "678",
            "nameEn": "Vanuatu",
            "nameLocal": "Vanuatu",
            "isoNumeric": 548
        },
        "currency": {
            "code": "VUV",
            "nameEn": "Vanuatu vatu",
            "symbol": "Vt",
            "paypal": "",
            "stripe": ""
        },
        "official": {
            "code": "bi",
            "nameEn": "Bislama",
            "nameLocal": "Bislama"
        },
        "tin": {
            "name": "",
            "type": ""
        },
        "flag": "🇻🇺",
        "region": "Asia & Pacific"
    },
    {
        "country": {
            "code": "WF",
            "code3": "WLF",
            "phoneCode": "681",
            "nameEn": "Wallis and Futuna",
            "nameLocal": "Wallis-et-Futuna",
            "isoNumeric": 876
        },
        "currency": {
            "code": "XPF",
            "nameEn": "CFP franc (franc Pacifique)",
            "symbol": "",
            "paypal": "",
            "stripe": ""
        },
        "official": {
            "code": "fr",
            "nameEn": "French",
            "nameLocal": "Français"
        },
        "tin": {
            "name": "",
            "type": ""
        },
        "flag": "🇼🇫",
        "region": "Asia & Pacific"
    },
    {
        "country": {
            "code": "WS",
            "code3": "WSM",
            "phoneCode": "685",
            "nameEn": "Samoa",
            "nameLocal": "Samoa",
            "isoNumeric": 882
        },
        "currency": {
            "code": "WST",
            "nameEn": "Samoan tala",
            "symbol": "WS$",
            "paypal": "",
            "stripe": ""
        },
        "official": {
            "code": "sm",
            "nameEn": "Samoan",
            "nameLocal": "gagana fa'a Samoa"
        },
        "tin": {
            "name": "",
            "type": ""
        },
        "flag": "🇼🇸",
        "region": "Asia & Pacific"
    },
    {
        "country": {
            "code": "YE",
            "code3": "YEM",
            "phoneCode": "967",
            "nameEn": "Yemen",
            "nameLocal": "اليَمَن",
            "isoNumeric": 887
        },
        "currency": {
            "code": "YER",
            "nameEn": "Yemeni rial",
            "symbol": "﷼",
            "paypal": "0",
            "stripe": "1"
        },
        "official": {
            "code": "ar",
            "nameEn": "Arabic",
            "nameLocal": "العربية"
        },
        "tin": {
            "name": "",
            "type": ""
        },
        "flag": "🇾🇪",
        "region": "Arab States"
    },
    {
        "country": {
            "code": "YT",
            "code3": "MYT",
            "phoneCode": "262",
            "nameEn": "Mayotte",
            "nameLocal": "Mayotte",
            "isoNumeric": 175
        },
        "currency": {
            "code": "EUR",
            "nameEn": "Euro",
            "symbol": "€",
            "paypal": "1",
            "stripe": "1"
        },
        "official": {
            "code": "fr",
            "nameEn": "French",
            "nameLocal": "Français"
        },
        "tin": {
            "name": "",
            "type": ""
        },
        "flag": "🇾🇹",
        "region": "Africa"
    },
    {
        "country": {
            "code": "ZA",
            "code3": "ZAF",
            "phoneCode": "27",
            "nameEn": "South Africa",
            "nameLocal": "South Africa",
            "isoNumeric": 710
        },
        "currency": {
            "code": "ZAR",
            "nameEn": "South African rand",
            "symbol": "R",
            "paypal": "0",
            "stripe": "1"
        },
        "official": {
            "code": "en",
            "nameEn": "English",
            "nameLocal": "English"
        },
        "tin": {
            "name": "",
            "type": ""
        },
        "flag": "🇿🇦",
        "region": "Africa"
    },
    {
        "country": {
            "code": "ZM",
            "code3": "ZMB",
            "phoneCode": "260",
            "nameEn": "Zambia",
            "nameLocal": "Zambia",
            "isoNumeric": 894
        },
        "currency": {
            "code": "ZMW",
            "nameEn": "Zambian kwacha",
            "symbol": "ZK",
            "paypal": "",
            "stripe": ""
        },
        "official": {
            "code": "en",
            "nameEn": "English",
            "nameLocal": "English"
        },
        "tin": {
            "name": "",
            "type": ""
        },
        "flag": "🇿🇲",
        "region": "Africa"
    },
    {
        "country": {
            "code": "ZW",
            "code3": "ZWE",
            "phoneCode": "263",
            "nameEn": "Zimbabwe",
            "nameLocal": "Zimbabwe",
            "isoNumeric": 716
        },
        "currency": {
            "code": "ZWL",
            "nameEn": "Zimbabwean dollar",
            "symbol": "Z$",
            "paypal": "",
            "stripe": ""
        },
        "official": {
            "code": "en",
            "nameEn": "English",
            "nameLocal": "English"
        },
        "tin": {
            "name": "",
            "type": ""
        },
        "flag": "🇿🇼",
        "region": "Africa"
    },
    {
        "country": {
            "code": "SZ",
            "code3": "SWZ",
            "phoneCode": "268",
            "nameEn": "Eswatini",
            "nameLocal": "Swaziland",
            "isoNumeric": 748
        },
        "currency": {
            "code": "SZL",
            "nameEn": "Swazi lilangeni",
            "symbol": "",
            "paypal": "",
            "stripe": ""
        },
        "official": {
            "code": "en",
            "nameEn": "English",
            "nameLocal": "English"
        },
        "tin": {
            "name": "",
            "type": ""
        },
        "flag": "🇸🇿",
        "region": "Africa"
    },
    {
        "country": {
            "code": "MK",
            "code3": "MKD",
            "phoneCode": "389",
            "nameEn": "North Macedonia",
            "nameLocal": "Македонија",
            "isoNumeric": 807
        },
        "currency": {
            "code": "MKD",
            "nameEn": "Macedonian denar",
            "symbol": "ден",
            "paypal": "0",
            "stripe": "1"
        },
        "official": {
            "code": "mk",
            "nameEn": "Macedonian",
            "nameLocal": "македонски јазик"
        },
        "tin": {
            "name": "",
            "type": ""
        },
        "flag": "🇲🇰",
        "region": "Europe"
    },
    {
        "country": {
            "code": "PH",
            "code3": "PHL",
            "phoneCode": "63",
            "nameEn": "Philippines",
            "nameLocal": "Philippines",
            "isoNumeric": 608
        },
        "currency": {
            "code": "PHP",
            "nameEn": "Philippine peso",
            "symbol": "Php",
            "paypal": "1",
            "stripe": "1"
        },
        "official": {
            "code": "en",
            "nameEn": "English",
            "nameLocal": "English"
        },
        "tin": {
            "name": "Tax Identification Number",
            "type": "TIN"
        },
        "flag": "🇵🇭",
        "region": "Asia & Pacific"
    },
    {
        "country": {
            "code": "NL",
            "code3": "NLD",
            "phoneCode": "31",
            "nameEn": "Netherlands",
            "nameLocal": "Nederland",
            "isoNumeric": 528
        },
        "currency": {
            "code": "EUR",
            "nameEn": "Euro",
            "symbol": "€",
            "paypal": "1",
            "stripe": "1"
        },
        "official": {
            "code": "nl",
            "nameEn": "Dutch, Flemish",
            "nameLocal": "Nederlands, Vlaams"
        },
        "tin": {
            "name": "Btw-nummer",
            "type": "Btw-nr."
        },
        "flag": "🇳🇱",
        "region": "Europe"
    },
    {
        "country": {
            "code": "AE",
            "code3": "ARE",
            "phoneCode": "971",
            "nameEn": "United Arab Emirates",
            "nameLocal": "دولة الإمارات العربيّة المتّحدة",
            "isoNumeric": 784
        },
        "currency": {
            "code": "AED",
            "nameEn": "United Arab Emirates dirham",
            "symbol": "",
            "paypal": "",
            "stripe": ""
        },
        "official": {
            "code": "ar",
            "nameEn": "Arabic",
            "nameLocal": "العربية"
        },
        "tin": {
            "name": "",
            "type": ""
        },
        "flag": "🇦🇪",
        "region": "Arab States"
    },
    {
        "country": {
            "code": "MD",
            "code3": "MDA",
            "phoneCode": "373",
            "nameEn": "Republic of Moldova",
            "nameLocal": "Moldova, Молдавия",
            "isoNumeric": 498
        },
        "currency": {
            "code": "MDL",
            "nameEn": "Moldovan leu",
            "symbol": "",
            "paypal": "",
            "stripe": ""
        },
        "official": {
            "code": "ro",
            "nameEn": "Romanian, Moldavian, Moldovan",
            "nameLocal": "Română"
        },
        "tin": {
            "name": "",
            "type": ""
        },
        "flag": "🇲🇩",
        "region": "Europe"
    },
    {
        "country": {
            "code": "GM",
            "code3": "GMB",
            "phoneCode": "220",
            "nameEn": "Gambia",
            "nameLocal": "The Gambia",
            "isoNumeric": 270
        },
        "currency": {
            "code": "GMD",
            "nameEn": "Gambian dalasi",
            "symbol": "D",
            "paypal": "",
            "stripe": ""
        },
        "official": {
            "code": "en",
            "nameEn": "English",
            "nameLocal": "English"
        },
        "tin": {
            "name": "",
            "type": ""
        },
        "flag": "🇬🇲",
        "region": "Africa"
    },
    {
        "country": {
            "code": "DO",
            "code3": "DOM",
            "phoneCode": "1",
            "nameEn": "Dominican Republic",
            "nameLocal": "República Dominicana",
            "isoNumeric": 214
        },
        "currency": {
            "code": "DOP",
            "nameEn": "Dominican peso",
            "symbol": "RD$",
            "paypal": "",
            "stripe": ""
        },
        "official": {
            "code": "es",
            "nameEn": "Spanish, Castilian",
            "nameLocal": "Español"
        },
        "tin": {
            "name": "Registro Nacional del Contribuyente",
            "type": "RNC"
        },
        "flag": "🇩🇴",
        "region": "South/Latin America"
    },
    {
        "country": {
            "code": "SD",
            "code3": "SDN",
            "phoneCode": "249",
            "nameEn": "Sudan",
            "nameLocal": "السودان",
            "isoNumeric": 736
        },
        "currency": {
            "code": "SDG",
            "nameEn": "Sudanese pound",
            "symbol": "",
            "paypal": "",
            "stripe": ""
        },
        "official": {
            "code": "ar",
            "nameEn": "Arabic",
            "nameLocal": "العربية"
        },
        "tin": {
            "name": "",
            "type": ""
        },
        "flag": "🇸🇩",
        "region": "Arab States"
    },
    {
        "country": {
            "code": "LA",
            "code3": "LAO",
            "phoneCode": "856",
            "nameEn": "Lao People's Democratic Republic",
            "nameLocal": "ປະຊາຊົນລາວ",
            "isoNumeric": 418
        },
        "currency": {
            "code": "LAK",
            "nameEn": "Lao kip",
            "symbol": "₭",
            "paypal": "0",
            "stripe": "1"
        },
        "official": {
            "code": "lo",
            "nameEn": "Lao",
            "nameLocal": "ພາສາລາວ"
        },
        "tin": {
            "name": "",
            "type": ""
        },
        "flag": "🇱🇦",
        "region": "Asia & Pacific"
    },
    {
        "country": {
            "code": "TW",
            "code3": "TWN",
            "phoneCode": "886",
            "nameEn": "Taiwan, Province of China",
            "nameLocal": "Taiwan",
            "isoNumeric": 158
        },
        "currency": {
            "code": "TWD",
            "nameEn": "New Taiwan dollar",
            "symbol": "NT$",
            "paypal": "1",
            "stripe": "1"
        },
        "official": {
            "code": "zh-hant",
            "nameEn": "",
            "nameLocal": ""
        },
        "tin": {
            "name": "",
            "type": ""
        },
        "flag": "🇹🇼",
        "region": "Asia & Pacific"
    },
    {
        "country": {
            "code": "CG",
            "code3": "COG",
            "phoneCode": "242",
            "nameEn": "Republic of the Congo",
            "nameLocal": "République du Congo",
            "isoNumeric": 178
        },
        "currency": {
            "code": "XAF",
            "nameEn": "CFA franc BEAC",
            "symbol": "FCF",
            "paypal": "",
            "stripe": ""
        },
        "official": {
            "code": "fr",
            "nameEn": "French",
            "nameLocal": "Français"
        },
        "tin": {
            "name": "",
            "type": ""
        },
        "flag": "🇨🇬",
        "region": "Africa"
    },
    {
        "country": {
            "code": "CZ",
            "code3": "CZE",
            "phoneCode": "420",
            "nameEn": "Czechia",
            "nameLocal": "Česká republika",
            "isoNumeric": 203
        },
        "currency": {
            "code": "CZK",
            "nameEn": "Czech koruna",
            "symbol": "Kč",
            "paypal": "1",
            "stripe": "1"
        },
        "official": {
            "code": "cs",
            "nameEn": "Czech",
            "nameLocal": "Čeština"
        },
        "tin": {
            "name": "Daňové identifikační číslo",
            "type": "DIČ"
        },
        "flag": "🇨🇿",
        "region": "Europe"
    },
    {
        "country": {
            "code": "GB",
            "code3": "GBR",
            "phoneCode": "44",
            "nameEn": "United Kingdom",
            "nameLocal": "Great Britain",
            "isoNumeric": 826
        },
        "currency": {
            "code": "GBP",
            "nameEn": "Pound sterling",
            "symbol": "£",
            "paypal": "1",
            "stripe": "1"
        },
        "official": {
            "code": "en",
            "nameEn": "English",
            "nameLocal": "English"
        },
        "tin": {
            "name": "Value added tax registration number",
            "type": "VAT Reg No"
        },
        "flag": "🇬🇧",
        "region": "Europe"
    },
    {
        "country": {
            "code": "NE",
            "code3": "NER",
            "phoneCode": "227",
            "nameEn": "Niger",
            "nameLocal": "Niger",
            "isoNumeric": 562
        },
        "currency": {
            "code": "XOF",
            "nameEn": "CFA franc BCEAO",
            "symbol": "",
            "paypal": "",
            "stripe": ""
        },
        "official": {
            "code": "fr",
            "nameEn": "French",
            "nameLocal": "Français"
        },
        "tin": {
            "name": "",
            "type": ""
        },
        "flag": "🇳🇪",
        "region": "Africa"
    },
    {
        "country": {
            "code": "CD",
            "code3": "COD",
            "phoneCode": "243",
            "nameEn": "Democratic Republic of the Congo",
            "nameLocal": "Democratic Republic of the Congo",
            "isoNumeric": 180
        },
        "currency": {
            "code": "CDF",
            "nameEn": "Congolese franc",
            "symbol": "",
            "paypal": "",
            "stripe": ""
        },
        "official": {
            "code": "fr",
            "nameEn": "French",
            "nameLocal": "Français"
        },
        "tin": {
            "name": "",
            "type": ""
        },
        "flag": "🇨🇩",
        "region": "Africa"
    },
    {
        "country": {
            "code": "BS",
            "code3": "BHS",
            "phoneCode": "1 242",
            "nameEn": "Commonwealth of The Bahamas",
            "nameLocal": "Commonwealth of The Bahamas",
            "isoNumeric": 44
        },
        "currency": {
            "code": "BSD",
            "nameEn": "Bahamian dollar",
            "symbol": "$",
            "paypal": "0",
            "stripe": "1"
        },
        "official": {
            "code": "en",
            "nameEn": "English",
            "nameLocal": "English"
        },
        "tin": {
            "name": "",
            "type": ""
        },
        "flag": "🇧🇸",
        "region": "Caribbean"
    },
    {
        "country": {
            "code": "CC",
            "code3": "CCK",
            "phoneCode": "61 891",
            "nameEn": "Cocos (Keeling) Islands",
            "nameLocal": "Pulu Kokos (Keeling)",
            "isoNumeric": 166
        },
        "currency": {
            "code": "AUD",
            "nameEn": "Australian dollar",
            "symbol": "$",
            "paypal": "1",
            "stripe": "1"
        },
        "official": {
            "code": "en",
            "nameEn": "English",
            "nameLocal": "English"
        },
        "tin": {
            "name": "",
            "type": ""
        },
        "flag": "🇨🇨",
        "region": "Australia"
    },
    {
        "country": {
            "code": "CF",
            "code3": "CAF",
            "phoneCode": "236",
            "nameEn": "Central African Republic",
            "nameLocal": "République centrafricaine",
            "isoNumeric": 140
        },
        "currency": {
            "code": "XAF",
            "nameEn": "Central African CFA",
            "symbol": "FCF",
            "paypal": "",
            "stripe": ""
        },
        "official": {
            "code": "fr",
            "nameEn": "French",
            "nameLocal": "Français"
        },
        "tin": {
            "name": "",
            "type": ""
        },
        "flag": "🇨🇫",
        "region": "Africa"
    },
    {
        "country": {
            "code": "CK",
            "code3": "COK",
            "phoneCode": "682",
            "nameEn": "Cook Islands",
            "nameLocal": "Kūki 'Āirani",
            "isoNumeric": 184
        },
        "currency": {
            "code": "NZD",
            "nameEn": "New Zealand dollar",
            "symbol": "$",
            "paypal": "1",
            "stripe": "1"
        },
        "official": {
            "code": "en",
            "nameEn": "English",
            "nameLocal": "English"
        },
        "tin": {
            "name": "",
            "type": ""
        },
        "flag": "🇨🇰",
        "region": "South Pacific Ocean"
    },
    {
        "country": {
            "code": "FK",
            "code3": "FLK",
            "phoneCode": "500",
            "nameEn": "Falkland Islands",
            "nameLocal": "Falkland Islands",
            "isoNumeric": 238
        },
        "currency": {
            "code": "FKP",
            "nameEn": "Falklands pound",
            "symbol": "£",
            "paypal": "0",
            "stripe": "1"
        },
        "official": {
            "code": "en",
            "nameEn": "English",
            "nameLocal": "English"
        },
        "tin": {
            "name": "",
            "type": ""
        },
        "flag": "🇫🇰",
        "region": "South Atlantic Ocean"
    },
    {
        "country": {
            "code": "FO",
            "code3": "FRO",
            "phoneCode": "298",
            "nameEn": "Faroe Islands",
            "nameLocal": "Færøerne",
            "isoNumeric": 234
        },
        "currency": {
            "code": "DKK",
            "nameEn": "Faroese króna",
            "symbol": "kr",
            "paypal": "1",
            "stripe": "1"
        },
        "official": {
            "code": "da",
            "nameEn": "Danish",
            "nameLocal": "dansk"
        },
        "tin": {
            "name": "",
            "type": ""
        },
        "flag": "🇫🇴",
        "region": "Europe"
    },
    {
        "country": {
            "code": "HM",
            "code3": "HMD",
            "phoneCode": "672",
            "nameEn": "Territory of Heard Island and McDonald Islands",
            "nameLocal": "Territory of Heard Island and McDonald Islands",
            "isoNumeric": 334
        },
        "currency": {
            "code": "AUD",
            "nameEn": "Australian dollar",
            "symbol": "$",
            "paypal": "1",
            "stripe": "1"
        },
        "official": {
            "code": "en",
            "nameEn": "English",
            "nameLocal": "English"
        },
        "tin": {
            "name": "",
            "type": ""
        },
        "flag": "🇭🇲",
        "region": "Indian Ocean"
    },
    {
        "country": {
            "code": "IO",
            "code3": "IOT",
            "phoneCode": "246",
            "nameEn": "British Indian Ocean Territory",
            "nameLocal": "British Indian Ocean Territory",
            "isoNumeric": 86
        },
        "currency": {
            "code": "USD",
            "nameEn": "United States Dollar",
            "symbol": "$",
            "paypal": "1",
            "stripe": "1"
        },
        "official": {
            "code": "en",
            "nameEn": "English",
            "nameLocal": "English"
        },
        "tin": {
            "name": "",
            "type": ""
        },
        "flag": "🇮🇴",
        "region": "Indian Ocean"
    },
    {
        "country": {
            "code": "KM",
            "code3": "COM",
            "phoneCode": "269",
            "nameEn": "Comoros",
            "nameLocal": "Umoja wa Komori",
            "isoNumeric": 174
        },
        "currency": {
            "code": "KMF",
            "nameEn": "Comorian franc",
            "symbol": "",
            "paypal": "",
            "stripe": ""
        },
        "official": {
            "code": "fr",
            "nameEn": "French",
            "nameLocal": "Français"
        },
        "tin": {
            "name": "",
            "type": ""
        },
        "flag": "🇰🇲",
        "region": "Indian Ocean"
    },
    {
        "country": {
            "code": "KY",
            "code3": "CYM",
            "phoneCode": "1 345",
            "nameEn": "Cayman Islands",
            "nameLocal": "Cayman Islands",
            "isoNumeric": 136
        },
        "currency": {
            "code": "KYD",
            "nameEn": "Cayman Islands dollar",
            "symbol": "$",
            "paypal": "0",
            "stripe": "1"
        },
        "official": {
            "code": "en",
            "nameEn": "English",
            "nameLocal": "English"
        },
        "tin": {
            "name": "",
            "type": ""
        },
        "flag": "🇰🇾",
        "region": "Caribbean Sea"
    },
    {
        "country": {
            "code": "MH",
            "code3": "MHL",
            "phoneCode": "692",
            "nameEn": "Republic of the Marshall Islands",
            "nameLocal": "Aolepān Aorōkin Ṃajeḷ",
            "isoNumeric": 584
        },
        "currency": {
            "code": "USD",
            "nameEn": "United States dollar",
            "symbol": "$",
            "paypal": "1",
            "stripe": "1"
        },
        "official": {
            "code": "en",
            "nameEn": "English",
            "nameLocal": "English"
        },
        "tin": {
            "name": "",
            "type": ""
        },
        "flag": "🇲🇭",
        "region": "Pacific Ocean"
    },
    {
        "country": {
            "code": "MP",
            "code3": "MNP",
            "phoneCode": "1 670",
            "nameEn": "Commonwealth of the Northern Mariana Islands",
            "nameLocal": "Sankattan Siha Na Islas Mariånas",
            "isoNumeric": 580
        },
        "currency": {
            "code": "USD",
            "nameEn": "United States dollar",
            "symbol": "$",
            "paypal": "1",
            "stripe": "1"
        },
        "official": {
            "code": "en",
            "nameEn": "English",
            "nameLocal": "English"
        },
        "tin": {
            "name": "",
            "type": ""
        },
        "flag": "🇲🇵",
        "region": "Pacific Ocean"
    },
    {
        "country": {
            "code": "TC",
            "code3": "TCA",
            "phoneCode": "1 649",
            "nameEn": "Turks and Caicos Islands",
            "nameLocal": "Turks and Caicos Islands",
            "isoNumeric": 796
        },
        "currency": {
            "code": "USD",
            "nameEn": "United States dollar",
            "symbol": "$",
            "paypal": "1",
            "stripe": "1"
        },
        "official": {
            "code": "en",
            "nameEn": "English",
            "nameLocal": "English"
        },
        "tin": {
            "name": "",
            "type": ""
        },
        "flag": "🇹🇨",
        "region": "Atlantic Ocean"
    },
    {
        "country": {
            "code": "TF",
            "code3": "ATF",
            "phoneCode": "672",
            "nameEn": "French Southern and Antarctic Lands",
            "nameLocal": "Terres australes et antarctiques françaises",
            "isoNumeric": 260
        },
        "currency": {
            "code": "EUR",
            "nameEn": "Euro",
            "symbol": "€",
            "paypal": "1",
            "stripe": "1"
        },
        "official": {
            "code": "fr",
            "nameEn": "French",
            "nameLocal": "Français"
        },
        "tin": {
            "name": "",
            "type": ""
        },
        "flag": "🇹🇫",
        "region": "Indian Ocean"
    },
    {
        "country": {
            "code": "UM",
            "code3": "UMI",
            "phoneCode": "246",
            "nameEn": "United States Minor Outlying Islands",
            "nameLocal": "United States Minor Outlying Islands",
            "isoNumeric": 581
        },
        "currency": {
            "code": "USD",
            "nameEn": "United States dollar",
            "symbol": "$",
            "paypal": "1",
            "stripe": "1"
        },
        "official": {
            "code": "en",
            "nameEn": "English",
            "nameLocal": "English"
        },
        "tin": {
            "name": "",
            "type": ""
        },
        "flag": "🇺🇲",
        "region": "Pacific Ocean"
    },
    {
        "country": {
            "code": "VA",
            "code3": "VAT",
            "phoneCode": "39",
            "nameEn": "Holy See",
            "nameLocal": "Sancta Sedes",
            "isoNumeric": 336
        },
        "currency": {
            "code": "EUR",
            "nameEn": "Euro",
            "symbol": "€",
            "paypal": "1",
            "stripe": "1"
        },
        "official": {
            "code": "la",
            "nameEn": "Latin",
            "nameLocal": "lingua latīna"
        },
        "tin": {
            "name": "",
            "type": ""
        },
        "flag": "🇻🇦",
        "region": "Europe"
    },
    {
        "country": {
            "code": "AN",
            "code3": "ANT",
            "phoneCode": "",
            "nameEn": "Netherlands Antilles",
            "nameLocal": "Netherlands Antilles",
            "isoNumeric": 530
        },
        "currency": {
            "code": "ANG",
            "nameEn": "Guilder",
            "symbol": "ƒ",
            "paypal": "0",
            "stripe": "1"
        },
        "official": {
            "code": "an",
            "nameEn": "Netherlands Antilles",
            "nameLocal": "Netherlands Antilles"
        },
        "tin": {
            "name": "",
            "type": ""
        },
        "flag": "",
        "region": ""
    },
    {
        "country": {
            "code": "CS",
            "code3": "SCG",
            "phoneCode": "",
            "nameEn": "Serbia and Montenegro",
            "nameLocal": "Serbia and Montenegro",
            "isoNumeric": 891
        },
        "currency": {
            "code": "RSD",
            "nameEn": "Dinar",
            "symbol": "Дин",
            "paypal": "0",
            "stripe": "1"
        },
        "official": {
            "code": "cs",
            "nameEn": "Serbia and Montenegro",
            "nameLocal": "Serbia and Montenegro"
        },
        "tin": {
            "name": "",
            "type": ""
        },
        "flag": "",
        "region": ""
    }
];
